import React, { useState, useEffect, forwardRef, useImperativeHandle, Suspense, useRef } from 'react';
import './QuotationActionFilteration.css';
import Swal from 'sweetalert2';
import API_ENDPOINTS from '../../../config/apiEndpoints';
import {
    ArrowLeft, Edit3, Banknote, GripVertical, Trash2, ChevronUp, ChevronDown, ChevronRight, User,
    Settings, CheckCircle2, XCircle, Clock, Share2, Mail, MessageSquare, MessageCircle,
    Send, Printer, Download, History, Copy, X, Search, Package, List, Tag, Percent, Image, Box as BoxIcon, Trash, Hash
} from 'lucide-react';
import Loader from '../../../components/Loader/Loader';
import TemplateService from '../../../services/TemplateService';
import LeadActionOperation from '../../../common/LeadActionOperation/LeadActionOperation';
import AddProductForm from '../../../components/LeadForm/AddProductForm';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';



import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

// Safe wrapper for ReactQuill to avoid concurrent rendering issues
const SafeQuill = React.memo(forwardRef((props, ref) => {
    const [mounted, setMounted] = useState(false);
    useEffect(() => { setMounted(true); }, []);
    if (!mounted) return <div className="quill-editor-wrap" style={{ minHeight: 120 }} />;
    return <ReactQuill ref={ref} {...props} />;
}));

const quillModules = {
    toolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ 'script': 'sub' }, { 'script': 'super' }],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        [{ 'indent': '-1' }, { 'indent': '+1' }],
        ['blockquote'],
        [{ 'align': [] }],
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'font': [] }],
        [{ 'size': ['small', false, 'large', 'huge'] }],
        [{ 'color': [] }, { 'background': [] }],
        ['image', 'link'],
        ['clean']
    ]
};

let globalNextQuotationNumber = parseInt(localStorage.getItem('lastQuotationNumber')) || 3067;

const NEWV3_BASE_URL_INTERNAL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
const NEW_BASE_URL_SERVICE = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
const GetLead_Details = `${NEWV3_BASE_URL_INTERNAL}${API_ENDPOINTS.COMMON.GET_LEAD_BY_ID}`.trim();
const Get_Quotation_Link = `${NEW_BASE_URL_SERVICE}${API_ENDPOINTS.INVOICE.PRINT_INVOICE}`;
const Mark_Sent = `${NEW_BASE_URL_SERVICE}${API_ENDPOINTS.Quotation.DELETE_QUOTATION}`;

const QuotationActionFilteration = forwardRef(({
    editView, setEditView,
    editForm, setEditForm,
    fetchQuotations,
    getToken,
    crmOperationPerms
}, ref) => {
    const NEWV3_BASE_URL = (process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, '');
    const TOKEN = API_ENDPOINTS.TOKE.UNIVERSAL_TOKEN;
    const API_BASE = (process.env.REACT_APP_WCF_API_BASE_URL || 'https://wcfkit19.azurewebsites.net').replace(/\/$/, '');
    const API_BASE_OLD ='https://wcftest.kit19.com';
    const NEW_BASE_URL = (process.env.REACT_APP_SERVICES_AZURE_BASEURL || '').replace(/\/$/, '');
    const OWNER_DROPDOWN = `${NEWV3_BASE_URL}${API_ENDPOINTS.INVOICE.GET_OWNER_DROPDOWN}`;
    const LEAD_tax = `${NEWV3_BASE_URL}${API_ENDPOINTS.INVOICE.GET_TAX_LIST_BYMODE_ENTITYID}`.trim();
     const Get_country = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_COUNTRY}`.trim();
       const Get_State = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_STATE_BY_COUNTRY}`.trim();
        const GET_CITY_URL = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_CITY_BY_STATE}`.trim();
    const Get_preview_list_edit = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_PREVIEW_LIST_EDIT}`.trim();

    const ADD_TAX_SUGGESTION_URL = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.ADD_TAX_SUGGESTION}`.trim();
    const ADD_ITEM_SUGGESTION_URL = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.ADD_ITEM_SUGGESTION}`.trim();
    const GET_DIFF_CUSTOMER_SUGGESTION_URL = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_DIFF_CUSTOMER_SUGGESTION}`.trim();
    const Get_currency = `${NEWV3_BASE_URL}/${API_ENDPOINTS.INVOICE.GET_CURRENCY_LIST}`.trim();
    const Insert_Quotation_New = `${NEWV3_BASE_URL}/${API_ENDPOINTS.Quotation.INSERT_QUOTATION_NEW.replace(/^\/+/, '')}`.trim();
    const Generate_Invoice = `${NEW_BASE_URL}${API_ENDPOINTS.Quotation.GENERATE_INVOICE_FOR_SHOW}`.trim();
    const SAVE_APPROVAL_URL = `${NEWV3_BASE_URL}${API_ENDPOINTS.INVOICE.SAVE_APPROVAL_SETTING}`.trim();
    const Get_Quotation_Details = `${NEWV3_BASE_URL}/${API_ENDPOINTS.Quotation.GET_QUOTATION_DETAILS_NEW.replace(/^\/+/, '')}`.trim();
   const Delete_Quotation = `${NEWV3_BASE_URL}/${API_ENDPOINTS.Quotation.DELETE_QUOTATION_NEW.replace(/^\/+/, '')}`.trim();
    const IsQuotation_Already_Generated = `${NEWV3_BASE_URL}/${API_ENDPOINTS.Quotation.IS_QUOTATION_ALREADY_GENERATED}`.trim();
    const Get_Approvers_Info = `${NEWV3_BASE_URL}/${API_ENDPOINTS.Quotation.GET_APPROVERS_INFO}`.trim();
    const Save_Approve_Data = `${API_BASE}${API_ENDPOINTS.Quotation.SAVE_APPROVE_DATA}`.trim();
    const GET_DOWNLOAD_TEMPLATE = `${NEW_BASE_URL}${API_ENDPOINTS.Quotation.GET_DOWNLOAD_TEMPLATE}`.trim();
    const GET_COMPANY_SETTING_DATA = `${NEWV3_BASE_URL}${API_ENDPOINTS.INVOICE.GET_COMPANY_SETTING_DATA}`.trim();

    // Product Management URLs
    const GET_UNIT_LIST_URL = `${NEW_BASE_URL}${API_ENDPOINTS.PRODUCT.GET_UNIT_LIST}`.trim();
    const GET_CATEGORY_LIST_URL = `${NEW_BASE_URL}${API_ENDPOINTS.PRODUCT.GET_CATEGORY_LIST}`.trim();
    const GET_TAX_LIST_URL = `${NEW_BASE_URL}${API_ENDPOINTS.PRODUCT.GET_TAX_LIST}`.trim();
    const GET_ACCOUNT_LIST_URL = `${NEW_BASE_URL}${API_ENDPOINTS.PRODUCT.GET_ACCOUNT_LIST}`.trim();
    const GET_TAG_LIST_URL = `${NEW_BASE_URL}${API_ENDPOINTS.PRODUCT.GET_TAG_LIST}`.trim();
    const GET_PRODUCT_CUSTOM_FIELDS_URL = `${NEW_BASE_URL}${API_ENDPOINTS.PRODUCT.GET_CUSTOM_FIELDS}`.trim();
    const SAVE_PRODUCT_URL = `${NEW_BASE_URL}${API_ENDPOINTS.PRODUCT.SAVE_PRODUCT}`.trim();
 //const Delete_Quotation = `${API_BASE}${API_ENDPOINTS.Quotation.DELETE_QUOTATION_NEW}`.trim();

    const DOWNLOAD_PDF =  `${NEWV3_BASE_URL}${API_ENDPOINTS.Quotation.DOWNLOAD_QUOTATION_PDF}`.trim();
     const Choose_Placeholder = `${NEWV3_BASE_URL}/${API_ENDPOINTS.Quotation.CHOOSE_PLACEHOLDER_FOR_PREVIEW.replace(/^\/+/, '')}`.trim();


    const safeStr = (v) => (v === null || v === undefined) ? '' : String(v).trim();

    const getFinancialYear = (format) => {
        const now = new Date();
        const nextYear = new Date(now);
        nextYear.setFullYear(now.getFullYear() + 1);

        const yy = now.getFullYear().toString().slice(-2);
        const yyyy = now.getFullYear();
        const nextYY = nextYear.getFullYear().toString().slice(-2);
        const nextYYYY = nextYear.getFullYear();

        switch (format) {
            case "YY-YY": return `${yy}-${nextYY}`;
            case "YYYY-YYYY": return `${yyyy}-${nextYYYY}`;
            case "YYYY-YY": return `${yyyy}-${nextYY}`;
            case "YYYY/YY": return `${yyyy}/${nextYY}`;
            case "YY/YY": return `${yy}/${nextYY}`;
            case "YYYY/YYYY": return `${yyyy}/${nextYYYY}`;
            default: return `${yy}-${nextYY}`;
        }
    };

    const padNumber = (num, digits) => {
        return num.toString().padStart(digits, "0");
    };

    const generateQuotationNumber = ({ prefix, nextNumber, numberDigits, financialYearFormat }) => {
        const finYear = getFinancialYear(financialYearFormat);
        const paddedNumber = padNumber(nextNumber, numberDigits);
        return `${prefix}/${finYear}/${paddedNumber}`;
    };

    const generateAddQuotationNumber = () => {
        const companySettings = {
            prefix: "QUO-654",
            nextNumber: globalNextQuotationNumber,
            numberDigits: 4,
            financialYearFormat: "YY/YY"
        };
        return generateQuotationNumber(companySettings);
    };

    const generateDuplicateNumber = (originalNum) => {
        if (!originalNum) return generateAddQuotationNumber();
        const parts = originalNum.split('/');
        if (parts.length > 0) {
            const lastPart = parts[parts.length - 1];
            if (!isNaN(lastPart) && lastPart.trim() !== '') {
                const nextNum = parseInt(lastPart, 10) + 1;
                parts[parts.length - 1] = padNumber(nextNum, lastPart.length);
                return parts.join('/');
            }
        }
        return `${originalNum}-COPY`;
    };

    const formatDate = (dateStr, includeTime = false) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return dateStr;
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        const day = String(d.getDate()).padStart(2, '0');
        const month = months[d.getMonth()];
        const year = d.getFullYear();
        let result = `${day}-${month}-${year}`;
        if (includeTime) {
            const h = String(d.getHours()).padStart(2, '0');
            const m = String(d.getMinutes()).padStart(2, '0');
            const s = String(d.getSeconds()).padStart(2, '0');
            result += ` ${h}:${m}:${s}`;
        }
        return result;
    };

    const toDateInputValue = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        if (isNaN(d.getTime())) return '';
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const getStandardStatus = (rawStatus) => {
        const s = String(rawStatus || '').toLowerCase();
        if (s.includes('converted') || s.includes('approved')) return 'Approved';
        if (s.includes('draft') || s.includes('open')) return 'Draft';
        if (s.includes('sent') || s.includes('pending')) return 'Sent For Approval';
        if (s.includes('canc') || s.includes('expir') || s.includes('reject')) return 'Cancelled';
        return 'Draft'; // Default
    };

    // ─── Date Picker Refs ─────────────────────────────────────────────────────
    const quotationDateRef = useRef(null);
    const dueDateRef = useRef(null);

    // ─── Edit View State ─────────────────────────────────────────────────────
    const [showView, setShowView] = useState(null);
    const [detailLoading, setDetailLoading] = useState(false);
    const [showFooter, setShowFooter] = useState(false);
    const [showHistory, setShowHistory] = useState(false);

    const [editLoading, setEditLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [companyOpen, setCompanyOpen] = useState(false);
    const [ownerOptions, setOwnerOptions] = useState([]);
    const [isDuplicateMode, setIsDuplicateMode] = useState(false);
    const [approversInfo, setApproversInfo] = useState(null);
    const [approvalState, setApprovalState] = useState({ open: false, status: 'Approved', remarks: '', loading: false });
    const [operationsOpen, setOperationsOpen] = useState(false);
    const [leadAction, setLeadAction] = useState({ open: false, mode: '', leadId: null });
    const [downloadModalOpen, setDownloadModalOpen] = useState(false);

    // Memoized handlers for Quill to avoid re-renders during save/loading
    const handleTermsChange = React.useCallback((val) => {
        setEditForm(prev => ({ ...prev, termsCondition: val }));
    }, [setEditForm]);

    const handleNotesChange = React.useCallback((val) => {
        setEditForm(prev => ({ ...prev, notes: val }));
    }, [setEditForm]);

    const handleFooterChange = React.useCallback((val) => {
        setEditForm(prev => ({ ...prev, footer: val }));
    }, [setEditForm]);

    // ─── Bill To Modal State ──────────────────────────────────────────────────
    const [billToOpen, setBillToOpen] = useState(false);
    const [billToForm, setBillToForm] = useState({});
    const [leadTaxOptions, setLeadTaxOptions] = useState([]);
    const [countryOptions, setCountryOptions] = useState([]);
    const [stateOptions, setStateOptions] = useState([]);
    const [cityOptions, setCityOptions] = useState([]);
    const [isSameAsBillTo, setIsSameAsBillTo] = useState(true);

    // --- Product Management State ---
    const [isProductAddOpen, setIsProductAddOpen] = useState(false);
    const [productSaving, setProductSaving] = useState(false);
    const [productForm, setProductForm] = useState({
        productName: '',
        sku: '',
        unitId: '',
        categoryId: '',
        salesPrice: 0,
        costPrice: 0,
        purchasePrice: 0,
        description: '',
        remarks: '',
        isTaxable: true,
        homeStateTaxIds: '',
        purchaseTaxId: '',
        otherTaxIds: '',
        salesAccount: '',
        costAccount: '',
        productTagsIds: '',
        isGoods: true,
        isServices: false,
        isCatalogue: false,
        isDigitalService: false,
        isActive: true,
        isPublished: true,
        isFeatured: false,
        isSaleable: true,
        hsnCode: '',
        sacCode: '',
        isInventoryTracked: false,
        initialStock: 0,
        reorderLevel: 0,
        preferredVendorId: '',
        weight: '',
        weightUnit: 'kg',
        dimensions: { length: '', width: '', height: '', unit: 'cm' },
        upc: '',
        ean: '',
        isbn: '',
        brand: '',
        manufacturer: '',
        decimalRateQuantity: 0,
        customFieldValueJson: '[]',
        variantsJson: '[]',
        vCombinationJson: '[]',
        thumbnailUrl: '',
        liveProductsURL: '',
        hasVariants: false
    });

    const [productOptions, setProductOptions] = useState({
        units: [],
        categories: [],
        taxes: [],
        accounts: [],
        tags: [],
        vendors: [],
        customFields: []
    });

    // Variant Management State (Top Level)
    const [variantRows, setVariantRows] = useState([{ id: Date.now(), name: '', values: '' }]);
    const [isCombinationCreated, setIsCombinationCreated] = useState(false);
    const [tagSearchText_Prd, setTagSearchText_Prd] = useState('');
    const [tagSuggestions_Prd, setTagSuggestions_Prd] = useState([]);

    const [shipToOpen, setShipToOpen] = useState(false);
    const [shipToForm, setShipToForm] = useState({
        name: '', email: '', phone: '', address: '', countryId: '', countryName: '', stateId: '', stateName: '', cityId: '', cityName: '', pincode: ''
    });

    // Item Edit Modals state
    const [itemEntityModal, setItemEntityModal] = useState({ open: false, index: -1, value: '' });
    const [itemDescModal, setItemDescModal] = useState({ open: false, index: -1, value: '', type: 'existing' });
    const [previewOptions, setPreviewOptions] = useState([]);
    const [placeholderOptions, setPlaceholderOptions] = useState([]);
    const [placeholderModalOpen, setPlaceholderModalOpen] = useState(false);
    const quillRef = React.useRef(null);

    // Per-item discount: { [itemKey]: { active, type, value } }
    const [itemDiscounts, setItemDiscounts] = useState({});

    // Per-item added taxes: { [itemKey]: [{ Id, Name, Rate, Type }] }
    const [itemAddedTaxes, setItemAddedTaxes] = useState({});

    // Per-item tax search: { [itemKey]: boolean }
    const [itemTaxSearchOpen, setItemTaxSearchOpen] = useState({});
    const [taxSearchText, setTaxSearchText] = useState('');
    const [taxSuggestions, setTaxSuggestions] = useState([]);

    // Add Item state
    const [addedItems, setAddedItems] = useState([]);
    const [itemSearchOpen, setItemSearchOpen] = useState(false);
    const [itemSearchText, setItemSearchText] = useState('');
    const [itemSuggestions, setItemSuggestions] = useState([]);

    // Add Charges state
    const [addedCharges, setAddedCharges] = useState([]); // [{ type, amount }]
    const [chargeModal, setChargeModal] = useState({ open: false, type: '', amount: '' });
    const [footerOpen, setFooterOpen] = useState(true);
    const [currencyList, setCurrencyList] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    useEffect(() => {
        if (editView && currencyList.length > 0) {
            if (editView._isAdd) {
                const inr = currencyList.find(c => c.Code === 'INR');
                if (inr) setSelectedCurrency(inr);
            } else {
                const currentCurrencyId = String(editView.CurrencyId || editView._quotation?.CurrencyId || '');
                if (currentCurrencyId) {
                    const matched = currencyList.find(c => String(c.Id) === currentCurrencyId);
                    if (matched) setSelectedCurrency(matched);
                }
            }
        }
    }, [editView, currencyList]);

    // Customer search state
    const [customerSearchOpen, setCustomerSearchOpen] = useState(false);
    const [customerSearchText, setCustomerSearchText] = useState('');
    const [customerSuggestions, setCustomerSuggestions] = useState([]);

    const cleanPin = (v) => {
        let s = String(v || "").trim();
        if (s === "0" || s === "000000") return "";
        // Fix: Remove extra appending "121213" as reported by user
        if (s.endsWith("121213") && s.length > 6) {
            s = s.slice(0, -6);
        }
        return s;
    };

    // ─── Customer Suggestion API ─────────────────────────────────────────────
    const fetchCustomerSuggestions = async (filterText) => {
        if (!filterText || filterText.length < 1) { setCustomerSuggestions([]); return; }
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const response = await fetch(GET_DIFF_CUSTOMER_SUGGESTION_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(userId, 10), FilterText: filterText } })
            });
            if (response.ok) {
                const data = await response.json();
                setCustomerSuggestions(data?.Details || data?.Details || data?.d || []);
            }
        } catch (err) {
            console.error('Customer suggestion error:', err);
        }
    };

    // --- Product Management Helpers ---
    const fetchProductFormOptions = async () => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const token = getToken ? getToken() : "-2295521862261168";
            
            const createPayload = (details) => JSON.stringify({
                Token: token,
                Details: JSON.stringify(details)
            });

            const [units, cats, taxes, accounts, customFields] = await Promise.all([
                fetch(GET_UNIT_LIST_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: createPayload({ UserId: parseInt(userId) }) }).then(res => res.json()).catch(() => ({ Details: [] })),
                fetch(GET_CATEGORY_LIST_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: createPayload({ UserId: parseInt(userId) }) }).then(res => res.json()).catch(() => ({ Details: [] })),
                fetch(GET_TAX_LIST_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: createPayload({ UserId: parseInt(userId) }) }).then(res => res.json()).catch(() => ({ Details: [] })),
                fetch(GET_ACCOUNT_LIST_URL, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: createPayload({ UserId: parseInt(userId) }) }).then(res => res.json()).catch(() => ({ Details: [] })),
                fetch(GET_PRODUCT_CUSTOM_FIELDS_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: createPayload({ UserId: parseInt(userId) })
                }).then(res => res.json()).catch(() => ({ Details: [] }))
            ]);

            setProductOptions(prev => ({
                ...prev,
                units: units?.Details || [],
                categories: cats?.Details || [],
                taxes: taxes?.Details || [],
                accounts: accounts?.Details || [],
                customFields: customFields?.Details || []
            }));
        } catch (err) {
            console.error('Error fetching product form options:', err);
        }
    };

    const fetchTagSuggestions_Prd = async (filter) => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const token = getToken ? getToken() : "-2295521862261168";
            const response = await fetch(GET_TAG_LIST_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Token: token,
                    Details: JSON.stringify({ strFilter: filter, UserId: parseInt(userId) })
                })
            });
            if (response.ok) {
                const data = await response.json();
                setTagSuggestions_Prd(data?.Details || []);
            }
        } catch (err) {
            console.error('Tag suggestion error:', err);
        }
    };

    const handleSaveProduct = async () => {
        if (!productForm.productName) {
            Swal.fire('Error', 'Product Name is required', 'error');
            return;
        }
        setProductSaving(true);
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const token = getToken ? getToken() : "-2295521862261168";
            
            const productDetails = {
                ...productForm,
                ProductID: "0",
                UserId: userId
            };
            
            const payload = {
                Token: token,
                Details: JSON.stringify(productDetails)
            };
            
            const response = await fetch(SAVE_PRODUCT_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const res = await response.json();
                if (res && res.Status === 1) {
                    Swal.fire({
                        title: 'Success',
                        text: 'Product saved successfully',
                        icon: 'success',
                        confirmButtonColor: '#16a34a'
                    });
                    setIsProductAddOpen(false);
                    if (res.Details && res.Details.product) {
                        handleSelectItem(res.Details.product);
                    }
                } else {
                    Swal.fire('Error', res?.Message || 'Failed to save product', 'error');
                }
            }
        } catch (err) {
            console.error('Save product error:', err);
            Swal.fire('Error', 'An error occurred while saving', 'error');
        } finally {
            setProductSaving(false);
        }
    };

    const resetProductForm = () => {
        setProductForm({
            productName: '',
            sku: '',
            unitId: '',
            categoryId: '',
            salesPrice: 0,
            costPrice: 0,
            purchasePrice: 0,
            description: '',
            remarks: '',
            isTaxable: true,
            homeStateTaxIds: '',
            purchaseTaxId: '',
            otherTaxIds: '',
            salesAccount: '',
            costAccount: '',
            productTagsIds: '',
            isGoods: true,
            isServices: false,
            isDigitalService: false,
            isActive: true,
            isPublished: true,
            isFeatured: false,
            isSaleable: true,
            hsnCode: '',
            sacCode: '',
            isInventoryTracked: false,
            initialStock: 0,
            reorderLevel: 0,
            preferredVendorId: '',
            weight: '',
            weightUnit: 'kg',
            dimensions: { length: '', width: '', height: '', unit: 'cm' },
            upc: '',
            ean: '',
            isbn: '',
            brand: '',
            manufacturer: '',
            decimalRateQuantity: 0,
            customFieldValueJson: '[]',
            variantsJson: '[]',
            vCombinationJson: '[]',
            thumbnailUrl: '',
            liveProductsURL: ''
        });
    };

    const fetchCompanySettings = async (isDuplicate = false, originalQuotationNumber = null) => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
          //  const GET_COMPANY_SETTING_DATA = `${REACT_APP_SERVICES_API_BASE_URL}${API_ENDPOINTS.INVOICE.GET_COMPANY_SETTING_DATA.replace(/^\/+/, '/')}`.trim();

            const payload = {
                Token: "-2295521862261168",
                Details: {
                    UserId: parseInt(userId, 10)
                }
            };
            const response = await fetch(GET_COMPANY_SETTING_DATA, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const data = await response.json();
                const companySettings = Array.isArray(data?.Details?.settings) ? data.Details.settings : (Array.isArray(data?.d) ? data.d : []);

                const getVal = (key, section) => {
                    const found = companySettings.find(s => s.Key?.toLowerCase() === key.toLowerCase() && s.Section?.toLowerCase() === section.toLowerCase());
                    return found ? found.Value : '';
                };

                const prefix = getVal('NumberPrefix', 'quotation') || 'QUO-654';
                const nextNumStr = getVal('NextNumber', 'quotation');
                const nextNum = parseInt(nextNumStr) || globalNextQuotationNumber;
                // Webforms ignores 'NumberDigit' setting if it's 0, and instead pads using the length of the NextNumber string itself.
                const digits = nextNumStr ? nextNumStr.length : (parseInt(getVal('NumberDigit', 'quotation')) || 4);
                const finYearFormat = getVal('FinancialYearFormat', 'quotation') || 'YY/YY';
                
                // Webforms treats duplicates exactly like new quotes for numbering 
                // It assigns the next available global number instead of incrementing the old quote's number
                const generatedNum = generateQuotationNumber({
                    prefix,
                    nextNumber: nextNum,
                    numberDigits: digits,
                    financialYearFormat: finYearFormat
                });

                setEditView(prev => ({
                    ...prev,
                    CompanyName: getVal('LegalName', 'company') || '',
                    CompanyEmail: getVal('Email', 'company') || '',
                    CompanyPhone: getVal('Phone', 'company') || getVal('PhoneNumber', 'company') || '',
                    CompanyAddress: getVal('HeadOffice', 'company') || getVal('Address', 'company') || '',
                    CompanyCountryId: getVal('CountryId', 'company') || '0',
                    CompanyStateId: getVal('StateId', 'company') || '0',
                    CompanyCityId: getVal('CityId', 'company') || '0',
                    CompanyPincode: getVal('Pincode', 'company') || '0',
                    CompanyLogo: getVal('Logo', 'company') || '',
                    CompanyTaxNumber: getVal('TaxNumber', 'company') || '',
                    CompanyPanNumber: getVal('PanNumber', 'company') || '',
                    CompanyTermCondition: getVal('TermCondition', 'quotation') || '',
                }));

                if (!isDuplicate) {
                    setEditForm(prev => ({
                        ...prev,
                        quotationNumber: generatedNum,
                        termsCondition: getVal('TermCondition', 'quotation') || '',
                        notes: getVal('Notes', 'quotation') || '',
                        footer: getVal('Footer', 'quotation') || '',
                        title: getVal('Title', 'quotation') || 'Quotation',
                        subheading: getVal('Subheading', 'quotation') || '',
                        placeOfOrigin: (['Berat', '1', ''].includes((getVal('State', 'company') || '').trim()) ? 'India' : (getVal('State', 'company') || 'India')),
                    }));
                } else {
                    // For duplication, we ONLY update the sequence number and branding
                    // but we keep the Notes, Footer, T&Cs, etc. from the original quote
                    setEditForm(prev => ({
                        ...prev,
                        quotationNumber: generatedNum
                    }));
                }
            }
        } catch (err) {
            console.error('Error fetching company settings:', err);
        }
    };

    const handleSelectCustomer = async (customer) => {
        const isNumeric = (val) => /^\d+$/.test(String(val || ''));

        // Helper to resolve name from API if ID is numeric
        const resolveStateName = async (cId, sId, currentName) => {
            if (!cId || !sId) return currentName;
            if (!isNumeric(sId) && !isNumeric(currentName) && currentName) return currentName;
            try {
                const res = await fetch(Get_State, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ Token: "-2295521862261168", Details: { CountryId: parseInt(String(cId), 10) } })
                });
                if (res.ok) {
                    const data = await res.json();
                    const list = data?.Details || data?.d || data?.Data || data?.data || data || [];
                    const match = list.find(o => String(o.Id || o.Value || o.Code) === String(sId));
                    if (match) return match.Text || match.Value || match.Name || '';
                }
            } catch (e) { console.error('resolveStateName error:', e); }
            return currentName;
        };

        const resolveCityName = async (sId, ctId, currentName) => {
            if (!sId || !ctId) return currentName;
            if (!isNumeric(ctId) && !isNumeric(currentName) && currentName) return currentName;
            try {
                const GET_CITY_URL = `${((process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, ''))}/Invoice/GetCityByState`;
                const res = await fetch(GET_CITY_URL, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ Token: "-2295521862261168", Details: { StateId: parseInt(String(sId), 10) } })
                });
                if (res.ok) {
                    const data = await res.json();
                    const list = data?.Details || data?.d || data?.Data || data?.data || data || [];
                    const match = list.find(o => String(o.Id || o.Value || o.Code) === String(ctId));
                    if (match) return match.Text || match.Value || match.Name || '';
                }
            } catch (e) { console.error('resolveCityName error:', e); }
            return currentName;
        };

        const name = customer.PersonName || customer.Name || '';
        const email = customer.EmailID || customer.Email || customer.EmailId || '';
        const phone = customer.MobileNo || customer.Mobile || customer.Phone || '';
        const company = customer.CompanyName || '';
        const address = customer.Address || '';
        const leadId = customer.LeadId || customer.Id || 0;

        const taxNumber = customer.TaxNumber || '';
        const panNumber = customer.PanNumber || '';
        
        const countryId = customer.CountryId || customer.countryid || customer.CountryID || (isNumeric(customer.Country) ? String(customer.Country) : '');
        let countryName = customer.Country || customer.CountryName || '';
        if ((isNumeric(countryName) && countryId) || (!countryName && countryId)) {
            const match = (countryOptions || []).find(o => String(o.Id || o.Value || o.Code) === String(countryId));
            if (match) countryName = match.Text || match.Name || '';
        }

        const stateId = customer.StateId || customer.stateid || customer.StateID || (isNumeric(customer.State) ? String(customer.State) : '') || '';
        let stateName = customer.State || customer.state || customer.StateName || '';
        stateName = await resolveStateName(countryId, stateId || stateName, stateName);

        const cityId = customer.CityId || customer.cityid || customer.CityID || (isNumeric(customer.City) ? String(customer.City) : '') || '';
        let cityName = customer.City || customer.city || customer.CityName || '';
        cityName = await resolveCityName(stateId || stateName, cityId || cityName, cityName);

        const pincode = cleanPin(customer.PinCode) || cleanPin(customer.pincode) || "";

        const commonData = {
            name: name,
            email: email,
            phone: phone,
            address: address,
            company: company,
            taxNumber: taxNumber,
            panNumber: panNumber,
            countryId: countryId,
            countryName: countryName,
            stateId: stateId,
            stateName: stateName,
            cityId: cityId,
            cityName: cityName,
            pincode: pincode,
        };

        setBillToForm(prev => ({ ...prev, ...commonData }));
        setShipToForm(prev => ({ ...prev, ...commonData }));

        const companyState = editView?.CompanyState || editView?.CompanyStateName || "";
        // Resolve company state if it's numeric
        let resolvedCompanyState = companyState === 'Berat' || companyState === '1' ? 'India' : companyState;
        if (isNumeric(companyState) && (editView?.CompanyCountryId || editView?.CompanyCountryID)) {
             resolvedCompanyState = await resolveStateName(editView.CompanyCountryId || editView.CompanyCountryID, companyState, companyState);
            if (resolvedCompanyState === 'Berat') resolvedCompanyState = 'India';
        }

        setEditForm(prev => ({
            ...prev,
            placeOfSupply: stateName || prev.placeOfSupply || resolvedCompanyState,
            placeOfOrigin: resolvedCompanyState || stateName || prev.placeOfOrigin
        }));

        setEditView(prev => ({
            ...prev,
            LeadId: parseInt(leadId),
            BillToName: name,
            BillToAddress: address,
            BillToEmailId: email,
            BillToMobileNo: phone,
            BillToTaxNumber: taxNumber,
            BillToPanNumber: panNumber,
            ShipToName: name,
            ShipToAddress: address,
            ShipToEmailId: email,
            ShipToMobileNo: phone,
            ShipToTaxNumber: taxNumber,
            ShipToPanNumber: panNumber,
            ContactName: name,
            ContactEmail: email,
            ContactPhone: phone,
            ContactAddress: address,
            ContactTaxNumber: taxNumber,
            ContactPanNumber: panNumber,
            leadDetail: {
                ...(prev?.leadDetail || {}),
                PersonName: name,
                MobileNo: phone,
                EmailID: email,
                Address: address,
                CompanyName: company,
                Country: countryName,
                CountryId: countryId,
                State: stateName,
                StateId: stateId,
                City: cityName,
                CityId: cityId,
                PinCode: pincode,
                TaxNumber: taxNumber,
                PanNumber: panNumber,
            }
        }));

        try {
            const token = getToken() || "-2295521862261168";
            const uid = localStorage.getItem('userId') || '34594';
            const detailsStr = JSON.stringify({
                draw: 1,
                StartNo: 0,
                EndNo: 1,
                UserId: parseInt(uid, 10),
                ParentId: parseInt(uid, 10),
                FilterText: `ID=${leadId}`
            });

            const response = await fetch(GetLead_Details, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    Token: token,
                    Details: detailsStr
                })
            });
            if (response.ok) {
                const fullRes = await response.json();
                let parsedDetails = fullRes?.Details;
                if (typeof parsedDetails === 'string') {
                    try { parsedDetails = JSON.parse(parsedDetails); } catch(e) {}
                }
                const fullLead = parsedDetails?.data?.[0] || parsedDetails || fullRes?.d || fullRes?.data || {};
                if (fullLead && Object.keys(fullLead).length > 0) {
                    const cId = fullLead.CountryId || fullLead.countryid || fullLead.CountryID || (isNumeric(fullLead.Country) ? String(fullLead.Country) : '');
                    const sId = fullLead.StateId || fullLead.stateid || fullLead.StateID || (isNumeric(fullLead.State) ? String(fullLead.State) : '');
                    const ctId = fullLead.CityId || fullLead.cityid || fullLead.CityID || (isNumeric(fullLead.City) ? String(fullLead.City) : '');
                    
                    let cNm = fullLead.CountryName || fullLead.Country || '';
                    if (isNumeric(cNm) || !cNm) {
                        const match = (countryOptions || []).find(o => String(o.Id || o.Value || o.Code) === String(cId || cNm));
                        if (match) cNm = match.Text || match.Name || '';
                    }

                    let sNm = fullLead.StateName || fullLead.State || '';
                    sNm = await resolveStateName(cId || countryId, sId || sNm, sNm);

                    let ctNm = fullLead.CityName || fullLead.City || '';
                    ctNm = await resolveCityName(sId || sNm, ctId || ctNm, ctNm);
                    const fTax = (fullLead.TaxNumber || '').trim();
                    const fPan = (fullLead.PanNumber || '').trim();

                    const fullData = {
                        countryId: cId || countryId,
                        countryName: cNm || countryName,
                        stateId: sId || stateId,
                        stateName: sNm || stateName,
                        cityId: ctId || cityId,
                        cityName: ctNm || cityName,
                        pincode: cleanPin(fullLead.PinCode) || cleanPin(fullLead.pincode) || pincode,
                        taxNumber: fTax || taxNumber,
                        panNumber: fPan || panNumber,
                        address: fullLead.Address || address
                    };

                    setBillToForm(prev => ({ ...prev, ...fullData }));
                    setShipToForm(prev => ({ ...prev, ...fullData }));

                    if (sNm || stateName) {
                        setEditForm(prev => ({
                            ...prev,
                            placeOfSupply: sNm || stateName,
                            placeOfOrigin: resolvedCompanyState || sNm || stateName || prev.placeOfOrigin
                        }));
                    }

                    setEditView(prev => ({
                        ...prev,
                        BillToTaxNumber: fTax || taxNumber,
                        BillToPanNumber: fPan || panNumber,
                        ShipToTaxNumber: fTax || taxNumber,
                        ShipToPanNumber: fPan || panNumber,
                        BillToCity: ctNm,
                        BillToState: sNm,
                        BillToCountry: cNm,
                        BillToPincode: fullData.pincode,
                        ShipToCity: ctNm,
                        ShipToState: sNm,
                        ShipToCountry: cNm,
                        ShipToPincode: fullData.pincode,
                        leadDetail: {
                            ...(prev?.leadDetail || {}),
                            ...fullLead,
                            CountryId: cId,
                            StateId: sId,
                            CityId: ctId,
                            Country: cNm,
                            State: sNm,
                            City: ctNm,
                            PinCode: fullData.pincode
                        }
                    }));

                    // Trigger dependent lookups
                    if (cId) fetchStates(cId);
                    if (sId) fetchCities(sId);
                }
            }
        } catch (err) {
            console.error('Error fetching full lead details in selection:', err);
        }

        // --- Fetch Lead Tax Options ---
        if (leadId) fetchLeadTax(leadId, true);

        setCustomerSearchOpen(false);
        setCustomerSearchText('');
        setCustomerSuggestions([]);
    };

    // ─── Tax Suggestion API ─────────────────────────────────────────────────
    const fetchTaxSuggestions = async (filterText) => {
        if (!filterText || filterText.length < 1) { setTaxSuggestions([]); return; }
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const response = await fetch(ADD_TAX_SUGGESTION_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    Token: "-2295521862261168", 
                    Details: { 
                        FilterText: filterText, 
                        UserId: parseInt(userId, 10) 
                    } 
                })
            });
            if (response.ok) {
                const data = await response.json();
                setTaxSuggestions(data?.Details || data?.d || []);
            }
        } catch (err) {
            console.error('Tax suggestion error:', err);
        }
    };

    const handleSelectTax = (tax, itemKey) => {
        const newTax = { Id: tax.Id, Name: tax.Name, Rate: parseFloat(tax.Rate) || 0, Type: tax.Type || 'percentage' };
        setItemAddedTaxes(prev => ({ ...prev, [itemKey]: [...(prev[itemKey] || []), newTax] }));
        setItemTaxSearchOpen(prev => ({ ...prev, [itemKey]: false }));
        setTaxSearchText('');
        setTaxSuggestions([]);
    };

    const handleDeleteAddedTax = (itemKey, taxIndex) => {
        setItemAddedTaxes(prev => ({ ...prev, [itemKey]: (prev[itemKey] || []).filter((_, i) => i !== taxIndex) }));
    };

    // ─── Item Suggestion API ────────────────────────────────────────────────
    const fetchItemSuggestions = async (filterText) => {
        if (!filterText || filterText.length < 1) { setItemSuggestions([]); return; }
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const response = await fetch(ADD_ITEM_SUGGESTION_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ 
                    Token: "-2295521862261168", 
                    Details: { 
                        FilterText: filterText, 
                        SectionName: "quotation", 
                        UserId: parseInt(userId, 10) 
                    } 
                })
            });
            if (response.ok) {
                const data = await response.json();
                setItemSuggestions(data?.Details || data?.Details || data?.d || []);
            }
        } catch (err) {
            console.error('Item suggestion error:', err);
        }
    };

    const handleSelectItem = (product) => {
        const price = parseFloat(product.SalePrice || product.Price || product.Rate || product.SalesPrice || 0);
        // Parse HSNCode from ProductJSON if available
        let hsnCode = product.HSNCode || product.SACCode || '';
        try { const pj = JSON.parse(product.ProductJSON || '{}'); hsnCode = pj.HSNCode || pj.SACCode || hsnCode; } catch (e) { }
        // Map HomeTaxes to quotationItemTaxes format
        const taxes = (product.HomeTaxes || []).map(t => ({
            Id: t.Id, Name: t.TaxName, Rate: t.TaxRate, Amount: (price * t.TaxRate) / 100, Type: t.TaxType || 'percentage'
        }));
        const taxNames = taxes.map(t => `${t.Name}: ${t.Rate}%`).join(', ');
        const taxAmount = taxes.reduce((s, t) => s + (t.Amount || 0), 0);
        const newItem = {
            Name: product.Name || product.ProductName || '-',
            Description: product.Description || '',
            Quantity: 1,
            Price: price,
            Total: price,
            ItemHsnSacCode: hsnCode,
            ItemTax: taxNames || '-',
            ItemTaxAmount: taxAmount > 0 ? `${taxNames}: ${taxAmount.toFixed(2)}` : '-',
            quotationItemTaxes: taxes,
        };
        setAddedItems(prev => [...prev, newItem]);
        setItemSearchOpen(false);
        setItemSearchText('');
        setItemSuggestions([]);
    };

    const handleDeleteAddedItem = (index) => {
        const key = `added-${index}`;
        setAddedItems(prev => prev.filter((_, i) => i !== index));
        setItemDiscounts(prev => { const n = { ...prev }; delete n[key]; return n; });
        setItemAddedTaxes(prev => { const n = { ...prev }; delete n[key]; return n; });
    };

    // Per-item discount helpers
    const getDiscount = (key) => itemDiscounts[key] || { active: false, type: 'percentage', value: 0 };
    const setDiscountForItem = (key, updater) => {
        setItemDiscounts(prev => ({
            ...prev,
            [key]: typeof updater === 'function' ? updater(prev[key] || { active: false, type: 'percentage', value: 0 }) : updater
        }));
    };

    // ─── API Functions ────────────────────────────────────────────────────────
    const fetchOwners = async () => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const response = await fetch(OWNER_DROPDOWN, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(userId, 10) } })
            });
            if (response.ok) {
                const data = await response.json();
                const list = data?.Status === 1 && data?.Details ? data.Details : (data?.Details || data?.d || data?.Data || data?.data || data || []);
                setOwnerOptions(Array.isArray(list) ? list : []);
            }
        } catch (err) {
            console.error('Error fetching owners:', err);
        }
    };

    const fetchCurrencyList = async () => {
        try {
            const response = await fetch(Get_currency, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: "" })
            });
            if (response.ok) {
                const data = await response.json();
                let list = data?.Details || data?.Details || data?.d || data?.Data || data?.data || [];
                if (Array.isArray(list)) {
                    list = list.map(c => {
                        if (c.Code === 'INR') {
                            return { ...c, Symbol: '₹' };
                        }
                        return c;
                    });
                    setCurrencyList(list);
                } else {
                    setCurrencyList([]);
                }
            }
        } catch (err) {
            console.error('Error fetching currencies:', err);
        }
    };

    const fetchLeadTax = async (leadId, autoPopulate = false) => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const res = await fetch(LEAD_tax, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ UserId: parseInt(userId, 10), EntityId: parseInt(leadId, 10), Mode: 'Lead' })
            });
            if (res.ok) {
                const data = await res.json();
                const list = data?.Details || data?.d || data?.Data || data?.data || data || [];
                setLeadTaxOptions(Array.isArray(list) ? list : []);

                // Auto-populate if requested and list is not empty
                if (autoPopulate && Array.isArray(list) && list.length > 0) {
                    const selected = list.find(o => o.IsDefault) || list[0];
                    if (selected) {
                        const taxNum = (selected.TaxNumber || '').trim();
                        const addr = selected.Address || '';
                        
                        const pin = cleanPin(selected.Pincode) || "";
                        
                        const updateData = {
                            leadTax: selected.Id || selected.Code || selected.Value || '',
                            taxNumber: taxNum,
                            address: addr,
                            pincode: pin,
                            countryId: selected.CountryId || '',
                            stateId: selected.StateId || '',
                            cityId: selected.CityId || '',
                        };

                        setBillToForm(prev => ({ ...prev, ...updateData }));
                        
                        if (selected.CountryId) fetchCountries();
                        if (selected.CountryId) fetchStates(selected.CountryId);
                        if (selected.StateId) fetchCities(selected.StateId);
                    }
                }
            }
        } catch (e) { console.error('fetchLeadTax', e); }
    };

    const fetchCountries = async () => {
        if (countryOptions.length > 0) return;
        try {
            const res = await fetch(Get_country, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: {} })
            });
            if (res.ok) {
                const data = await res.json();
                const list = data?.Details || data?.d || data?.Data || data?.data || data || [];
                setCountryOptions(Array.isArray(list) ? list : []);
            }
        } catch (e) { console.error('fetchCountries', e); }
    };

    const fetchStates = async (countryId) => {
        setStateOptions([]); setCityOptions([]);
        try {
            const res = await fetch(Get_State, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { CountryId: parseInt(String(countryId), 10) } })
            });
            if (res.ok) {
                const data = await res.json();
                const list = data?.Details || data?.d || data?.Data || data?.data || data || [];
                setStateOptions(Array.isArray(list) ? list : []);
            }
        } catch (e) { console.error('fetchStates', e); }
    };

    const fetchCities = async (stateId) => {
        setCityOptions([]);
        try {
            //const GET_CITY_URL = `${((process.env.REACT_APP_SERVICES_API_BASE_URL || '').replace(/\/$/, ''))}/Invoice/GetCityByState`;
            const res = await fetch(GET_CITY_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { StateId: parseInt(String(stateId), 10) } })
            });
            if (res.ok) {
                const data = await res.json();
                const list = data?.Details || data?.d || data?.Data || data?.data || data || [];
                setCityOptions(Array.isArray(list) ? list : []);
            }
        } catch (e) { console.error('fetchCities', e); }
    };

    const fetchPreviewSuggestions = async () => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const payload = { Token: "-2295521862261168", Details: { UserId: parseInt(userId, 10) } };
            const response = await fetch(Get_preview_list_edit, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const data = await response.json();
                const list = data?.Details || data?.Details || data?.d || data?.Data || [];
                setPreviewOptions(Array.isArray(list) ? list : []);
            }
        } catch (e) {
            console.error('Error fetching preview suggestions:', e);
        }
    };

    // ─── Action Handlers ──────────────────────────────────────────────────────
    const openBillToModal = (d) => {
        const leadId = d.LeadId || d._invoice?.LeadId || d._quotation?.LeadId || '';
        const ld = d.leadDetail || {};
        const b = billToForm;

        const isNumeric = (val) => /^\d+$/.test(String(val || ''));

        let countryId = b.countryId || d.CountryId || d.countryid || d.Country_Id || ld.CountryId || ld.countryid || (isNumeric(d.Country || ld.Country) ? String(d.Country || ld.Country) : '');
        let stateId = b.stateId || d.StateId || d.stateid || d.State_Id || ld.StateId || ld.stateid || (isNumeric(d.State || ld.State) ? String(d.State || ld.State) : '');
        let cityId = b.cityId || d.CityId || d.cityid || d.City_Id || ld.CityId || ld.cityid || (isNumeric(d.City || ld.City) ? String(d.City || ld.City) : '');

        const countryName = b.countryName || d.Country || d.CountryName || ld.Country || ld.CountryName || '';
        let stateName = b.stateName || d.State || d.StateName || ld.State || ld.StateName || '';
        let cityName = b.cityName || d.City || d.CityName || ld.City || ld.CityName || '';

        // Final sanity check for ID values leak in names
        if (isNumeric(stateName) && stateId) {
            const match = (stateOptions || []).find(o => String(o.Id || o.Value || o.Code) === String(stateId));
            if (match) stateName = match.Text || match.Value || match.Name || '';
        }
        if (isNumeric(cityName) && cityId) {
            const match = (cityOptions || []).find(o => String(o.Id || o.Value || o.Code) === String(cityId));
            if (match) cityName = match.Text || match.Value || match.Name || '';
        }

        setBillToForm({
            name: d.ContactName || ld.PersonName || '',
            email: d.ContactEmail || ld.EmailID || '',
            phone: d.ContactPhone || ld.MobileNo || '',
            taxNumber: (d.ContactTaxNumber || ld.TaxNumber || '').trim(),
            panNumber: (d.ContactPanNumber || ld.PanNumber || '').trim(),
            address: d.ContactAddress || ld.Address || '',
            countryId: countryId,
            countryName: countryName,
            stateId: stateId,
            stateName: stateName,
            cityId: cityId,
            cityName: cityName,
            pincode: cleanPin(d.BillToPincode) || cleanPin(d.PinCode) || cleanPin(ld.PinCode) || '',
            leadTax: '',
        });

        if (countryId) fetchStates(countryId);
        if (stateId) fetchCities(stateId);

        fetchLeadTax(leadId, true);
        fetchCountries();
        setBillToOpen(true);
    };

    const openShipToModal = (invData) => {
        const countryId = invData.ShipToCountryId || invData.countryid || invData.CountryId || (invData.leadDetail?.CountryId) || (invData.leadDetail?.countryid) || '';
        const stateId = invData.ShipToStateId || invData.stateid || invData.StateId || (invData.leadDetail?.StateId) || (invData.leadDetail?.stateid) || '';
        const cityId = invData.ShipToCityId || invData.cityid || invData.CityId || (invData.leadDetail?.CityId) || (invData.leadDetail?.cityid) || '';

        const sf = {
            name: safeStr(invData.ShipToName || invData.ContactName || invData.leadDetail?.PersonName),
            email: safeStr(invData.ShipToEmailId || invData.ContactEmail || invData.leadDetail?.EmailID),
            phone: safeStr(invData.ShipToPhone || invData.ContactPhone || invData.leadDetail?.MobileNo),
            address: safeStr(invData.ShipToAddress || invData.ContactAddress || invData.leadDetail?.Address),
            countryId: countryId,
            countryName: safeStr(invData.ShipToCountryName || invData.CountryName || invData.leadDetail?.Country),
            stateId: stateId,
            stateName: safeStr(invData.ShipToStateName || invData.StateName || invData.leadDetail?.State),
            cityId: cityId,
            cityName: safeStr(invData.ShipToCityName || invData.CityName || invData.leadDetail?.City),
            pincode: cleanPin(invData.ShipToPincode) || cleanPin(invData.BillToPincode) || cleanPin(invData.leadDetail?.PinCode) || cleanPin(invData.ContactPincode) || cleanPin(invData.Pincode) || ''
        };
        setShipToForm(sf);

        if (countryId) fetchStates(countryId);
        if (stateId) fetchCities(stateId);

        fetchCountries();
        setShipToOpen(true);
    };

    const handleDeleteItem = (index) => {
        if (!editView) return;
        const newItems = [...(editView.quotationItems || [])];
        newItems.splice(index, 1);
        setEditView(prev => ({ ...prev, quotationItems: newItems }));
    };

    const handleApplyItemEdit = (index, field, value, type = 'existing') => {
        if (!editView) return;
        if (type === 'added') {
            const newItems = [...addedItems];
            if (newItems[index]) {
                newItems[index] = { ...newItems[index], [field]: value };
                setAddedItems(newItems);
            }
        } else {
            const newItems = [...(editView.quotationItems || [])];
            if (newItems[index]) {
                newItems[index] = { ...newItems[index], [field]: value };
                setEditView(prev => ({ ...prev, quotationItems: newItems }));
            }
        }
    };

    const handleSave = async () => {
        if (!editView) return;
        const d = editView;
        const errors = [];

        const b = billToForm;
        const s = isSameAsBillTo ? b : shipToForm;

        const checkValid = (id, name) => {
            const hasId = id !== undefined && id !== null && String(id) !== '0' && String(id).trim() !== '';
            const hasName = name !== undefined && name !== null && String(name).trim() !== '';
            return hasId || hasName;
        };

        if (!b.phone) errors.push("Mobile number is required for bill to.");
        if (!checkValid(b.countryId, b.countryName)) errors.push("Country is required for bill to.");
        if (!checkValid(b.stateId, b.stateName)) errors.push("State is required for bill to.");
        if (!checkValid(b.cityId, b.cityName)) errors.push("City is required for bill to.");

        if (!s.phone) errors.push("Mobile number is required for ship to.");
        if (!checkValid(s.countryId, s.countryName)) errors.push("Country is required for ship to.");
        if (!checkValid(s.stateId, s.stateName)) errors.push("State is required for ship to.");
        if (!checkValid(s.cityId, s.cityName)) errors.push("City is required for ship to.");

        if (errors.length > 0) {
            Swal.fire({
                title: 'Validation Failed',
                html: errors.join('<br/>'),
                icon: 'warning',
                confirmButtonColor: '#28a745'
            });
            return;
        }

        setSaveLoading(true);
        try {
            // Recalculate totals for payload (consistent with render)
            const lineItems = d.quotationItems || [];
            const allItems = [
                ...lineItems.map((item, i) => ({ ...item, _key: `existing-${i}`, _type: 'existing', _idx: i })),
                ...addedItems.map((item, i) => ({ ...item, _key: `added-${i}`, _type: 'added', _idx: i })),
            ];

            let subTotal = 0;
            const itemsPayload = allItems.map(item => {
                const itemTotal = parseFloat(item.Total || 0);
                subTotal += itemTotal;
                const key = item._key;
                const disc = itemDiscounts[key] || { active: false, type: 'percentage', value: 0 };
                let itemDiscAmt = 0;
                if (disc.active && disc.value > 0) {
                    itemDiscAmt = disc.type === 'percentage' ? (itemTotal * disc.value) / 100 : parseFloat(disc.value) || 0;
                }
                const itemAfterDisc = itemTotal - itemDiscAmt;

                const taxCharges = [];
                // Existing taxes
                (item.quotationItemTaxes || []).forEach(t => {
                    const rate = parseFloat(t.Rate || 0);
                    const amt = disc.active && rate > 0 ? (itemAfterDisc * rate) / 100 : parseFloat(t.Amount || 0);
                    taxCharges.push({ TCName: t.Name, TCId: t.TaxId || '0', TCRate: rate, TCType: 'P', TCAmount: amt.toFixed(2) });
                });
                // Added taxes
                (itemAddedTaxes[key] || []).forEach(at => {
                    const amt = at.Type === 'fixed' ? at.Rate : (itemAfterDisc * at.Rate) / 100;
                    taxCharges.push({ TCName: at.Name, TCId: at.Id || '0', TCRate: at.Rate, TCType: at.Type === 'fixed' ? 'V' : 'P', TCAmount: amt.toFixed(2) });
                });

                const taxLabel = taxCharges.map(tc => `${tc.TCName} : ${tc.TCRate}${tc.TCType === 'P' ? '%' : ''}`).join(', ');
                const taxAmtLabel = taxCharges.map(tc => `${tc.TCName} : ${tc.TCAmount}`).join(', ');

                return {
                    ItemName: item.ItemName || item.Name || '',
                    ItemId: isDuplicateMode ? '0' : (item.ItemId || item.Id || '0'),
                    ItemSKU: String(item.ItemSKU || item.Sku || ''),
                    ItemDescription: item.ItemDescription || item.Description || '',
                    ItemHsnSacCode: item.ItemHsnSacCode || item.HSNCode || '',
                    ItemTax: taxLabel,
                    ItemTaxAmount: taxAmtLabel,
                    AdditionalEntities: {},
                    ItemVolume: parseFloat(item.ItemVolume || item.Quantity || 1),
                    ItemPrice: parseFloat(item.ItemPrice || item.Price || item.SalePrice || 0),
                    ItemAmount: itemTotal.toFixed(2),
                    ItemTaxCharges: taxCharges
                };
            });

            const taxSum = itemsPayload.reduce((sum, itm) => {
                return sum + itm.ItemTaxCharges.reduce((s, tc) => s + parseFloat(tc.TCAmount), 0);
            }, 0);

            const totalDisc = allItems.reduce((sum, itm) => {
                const disc = itemDiscounts[itm._key];
                if (disc?.active) {
                    return sum + (disc.type === 'percentage' ? (parseFloat(itm.Total) * disc.value) / 100 : parseFloat(disc.value));
                }
                return sum;
            }, 0);

            const chargesTotal = addedCharges.reduce((s, c) => s + (parseFloat(c.amount) || 0), 0);
            const grandTotal = subTotal - totalDisc + taxSum + chargesTotal;

            const userId = localStorage.getItem('userId') || '34594';

            const invoiceBody = {
                QuotationId: String(isDuplicateMode ? 0 : (d.Id || d.QuoteId || d.QuotationId || d.InvoiceId || 0)),
                BillToLeadId: parseInt(d.LeadId || 0),
                CompanyName: d.CompanyName || 'My Company', // Fallback to prevent backend crash (Index out of bounds)
                CompanyEmail: d.CompanyEmail || '',
                CompanyPhone: d.CompanyPhone || '',
                CompanyAddress: d.CompanyAddress || '',
                CompanyTaxNumber: d.CompanyTaxNumber || '',
                CompanyPanNumber: d.CompanyPanNumber || '',
                CurrencyId: String(selectedCurrency?.Id || d.CurrencyId || '2'),
                CompanyTermCondition: editForm.termsCondition || '',
                CustomerNotes: editForm.notes || '',
                QuotationFooter: editForm.footer || '',
                CompanyLogo: d.CompanyLogo ? (d.CompanyLogo.split('/').pop()) : '',
                QuotaionTitle: editForm.title || '',
                QuotaionSubHeading: editForm.subheading || '',
                QuotationNotes: '', // WebForms sends QuotationNotes as empty; CustomerNotes carries the notes content
                CompanyCountryId: String(d.CompanyCountryId || '0'),
                CompanyStateId: String(d.CompanyStateId || '0'),
                CompanyCityId: String(d.CompanyCityId || '0'),
                CompanyPincode: String(d.CompanyPincode || '0'),
                CompanyOriginId: String(d.CompanyOriginId || '0'),
                CompanyOriginName: editForm.placeOfOrigin || '',
                CompanySupplyName: editForm.placeOfSupply || '',
                PlaceOfSupply: editForm.placeOfSupply || '',
                PlaceOfOrigin: editForm.placeOfOrigin || '',
                BillToName: b.name || d.BillToName || '',
                BillToCompanyName: b.company || '',
                BillToType: d.BillToType || d.ContactType || 'Lead',
                BillToTaxNumber: b.taxNumber || d.ContactTaxNumber || '',
                BillToPanNumber: b.panNumber || d.ContactPanNumber || '',
                BillToEmailId: b.email || d.ContactEmail || '',
                BillToPhoneNumber: b.phone || d.ContactPhone || '',
                BillToAddress: b.address || d.ContactAddress || '',
                VariantsCollection: "",
                BillToCountryId: String(b.countryId || '0'),
                BillToStateId: String(b.stateId || '0'),
                BillToCityId: String(b.cityId || '0'),
                BillToPincode: String(b.pincode || '0'),
                ShipToName: s.name || '',
                ShipToCompanyName: s.company || '',
                ShipToEmailId: s.email || '',
                ShipToPhone: s.phone || '',
                ShipToAddress: s.address || '',
                ShipToCountryId: String(s.countryId || '0'),
                ShipToStateId: String(s.stateId || '0'),
                ShipToCityId: String(s.cityId || '0'),
                ShipToPincode: String(s.pincode || '0'),
                QuotationNumber: editForm.quotationNumber || '',
                SalesOwner: parseInt(editForm.salesOwner || userId),
                QuotationDate: formatDate(editForm.quotationDate),
                QuotationDueDate: formatDate(editForm.dueDate),
                QuotationSubTotal: subTotal.toFixed(2),
                QuotationTotal: grandTotal.toFixed(2),
                Items: itemsPayload,
                AdditionalItems: addedCharges.map(c => ({ Name: c.type, Amount: parseFloat(c.amount).toFixed(2) }))
            };



            // 1. Validation Pre-flight: Check if Quotation Number already exists (Only for NEW records)
            if (editView?._isAdd) {
                let currentNum = editForm.quotationNumber;
                let isUnique = false;
                let attempts = 0;
                
                while (!isUnique && attempts < 10) {
                    const valPayload = {
                        Token: "-2295521862261168",
                        Details: {
                            InvoiceNumber: currentNum || '',
                            UserId: parseInt(userId, 10)
                        }
                    };
                    const valResponse = await fetch(IsQuotation_Already_Generated, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(valPayload)
                    });
                    
                    if (valResponse.ok) {
                        const valData = await valResponse.json();
                        const checkMsg = valData?.Details || valData?.d;
                        // If checkMsg is not empty string and not "Not Available", it's an error message saying it exists
                        if (checkMsg && checkMsg !== "" && checkMsg !== "Not Available") {
                            currentNum = generateDuplicateNumber(currentNum);
                            attempts++;
                        } else {
                            isUnique = true;
                        }
                    } else {
                        // Network error in validation, proceed anyway or let it fail at save
                        isUnique = true; 
                    }
                }
                
                if (currentNum !== editForm.quotationNumber) {
                    setEditForm(prev => ({ ...prev, quotationNumber: currentNum }));
                    invoiceBody.QuotationNumber = currentNum;
                    
                    // Sync the global counter to avoid future collisions
                    const parts = currentNum.split('/');
                    const lastPart = parts[parts.length - 1];
                    if (!isNaN(lastPart) && lastPart.trim() !== "") {
                        globalNextQuotationNumber = parseInt(lastPart, 10);
                    }
                }
                
                if (!isUnique) {
                    throw new Error("Could not generate a unique Quotation Number. Please enter one manually.");
                }
            }

            const payload = {
                Token: "-2295521862261168",
                Details: {
                    QuotationData: JSON.stringify(invoiceBody),
                    UserId: parseInt(userId, 10)
                }
            };

            const response = await fetch(Insert_Quotation_New, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const resData = await response.json();
                if (resData?.Status === 1 || resData?.Message === 'Success' || resData?.d === 'Success' || resData?.Success || resData?.d === true || (typeof resData?.d === 'string' && resData?.d?.includes('Success')) || (typeof resData?.d === 'number' && resData.d > 0) || (typeof resData?.d === 'string' && !isNaN(resData.d) && parseInt(resData.d) > 0)) {

                    if (editView?._isAdd) {
                        globalNextQuotationNumber++;
                        localStorage.setItem('lastQuotationNumber', globalNextQuotationNumber);
                    }

                    const successMsg = isDuplicateMode
                        ? (editView?._isAdd ? 'Quotation created successfully' : 'Quotation duplicated successfully')
                        : 'Quotation updated successfully';
                    Swal.fire({
                        title: 'Success',
                        text: successMsg,
                        icon: 'success',
                        confirmButtonColor: '#28a745'
                    });
                    setEditView(null);
                    if (fetchQuotations) fetchQuotations();

                    // Automatic Preview for new quotations
                    const newId = resData?.QuotationId || resData?.Details || resData?.Id || resData?.ID || (typeof resData?.d === 'number' ? resData.d : (typeof resData?.d === 'string' && !isNaN(resData.d) ? parseInt(resData.d) : null));
                    if (newId) {
                        handleShowQuotation({ Id: newId });
                    }
                } else {
                    throw new Error(resData?.Details || resData?.Message || (typeof resData?.d === 'string' ? resData.d : 'Failed to save quotation'));
                }
            } else {
                throw new Error('Network response was not ok');
            }
        } catch (err) {
            console.error('Save error:', err);
            Swal.fire({
                title: 'Error',
                text: err.message || 'Something went wrong while saving.',
                icon: 'error',
                confirmButtonColor: '#ef4444'
            });
        } finally {
            setSaveLoading(false);
        }
    };

    // Expose handlers to parent via ref
    useImperativeHandle(ref, () => ({
        handleEditQuotation: (inv) => handleEditQuotation(inv, false),
        handleDuplicateQuotation: (inv) => handleEditQuotation(inv, true),
        handleAddQuotation: (leadId) => handleAddQuotation(leadId),
        handleRequestApproval: (inv) => handleRequestApproval(inv),
        handleShowQuotation: (inv) => handleShowQuotation(inv),
        handleDeleteQuotation: (inv) => handleDeleteQuotation(inv),
        handleCancelQuotation: (inv) => handleCancelQuotation(inv),
        handlePrint: (inv) => handlePrint(inv),
        handleMarkAsSent: (inv) => handleMarkAsSent(inv)
    }));

    const handleMarkAsSent = async (customQuotation = null) => {
        const qSource = customQuotation || showView;
        const quoteId = qSource?.QuoteId || qSource?.QuotationId || qSource?.ID || qSource?.Details?.Id || qSource?.Id || (qSource?._quotation?.QuoteId || qSource?._quotation?.QuotationId || qSource?._quotation?.ID || qSource?._quotation?.Id);

        if (!quoteId) return;

        const result = await Swal.fire({
            title: 'Mark as Sent',
            text: 'Are you sure you want to mark this quotation as sent?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#10b981',
            cancelButtonColor: '#6e7881',
            confirmButtonText: 'Yes, mark it!'
        });

        if (result.isConfirmed) {
            try {
                const token = getToken() || "-2295521862261168";
                const userId = localStorage.getItem('userId') || '34594';

                const res = await fetch(Mark_Sent, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        Token: token,
                        Details: {
                            QuoteIds: String(quoteId),
                            Mode: "marksent",
                            UserId: parseInt(userId, 10)
                        }
                    })
                });

                if (res.ok) {
                    const resData = await res.json();
                    if (resData?.Status === 1 || resData?.Message === 'Success' || resData?.d === 'Success' || resData?.Success || resData?.d === true) {
                        Swal.fire({ title: 'Success', text: 'Quotation marked as sent.', icon: 'success' });

                        if (customQuotation) {
                            // If called from list, list will refresh anyway
                        } else if (showView) {
                            setShowView(prev => ({
                                ...prev,
                                Status: 'Sent',
                                _quotation: prev._quotation ? { ...prev._quotation, Status: 'Sent' } : prev._quotation
                            }));
                        }

                        if (fetchQuotations) fetchQuotations();
                        if (!customQuotation) setShowView(null);
                    } else {
                        throw new Error(resData?.Message || resData?.d || 'Failed to update status');
                    }
                } else {
                    throw new Error('Network response was not ok');
                }
            } catch (e) {
                Swal.fire({ title: 'Error', text: e.message || 'Update failed.', icon: 'error' });
            }
        }
    };

    const handleCancelQuotation = async (quotation) => {
        const result = await Swal.fire({
            title: 'Cancel Quotation',
            text: 'Are you sure you want to cancel this quotation?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ef4444',
            cancelButtonColor: '#6e7881',
            confirmButtonText: 'Yes, cancel it!'
        });

        if (!result.isConfirmed) return;

        try {
            const quotationId = quotation.QuoteId || quotation.QuotationId || quotation.ID || quotation.Id;
            const userId = localStorage.getItem('userId') || '34594';

            const payload = {
                Token: TOKEN,
                Details: {
                    QuoteIds: String(quotationId),
                    Mode: "cancelled",
                    UserId: parseInt(userId, 10)
                }
            };

            const response = await fetch(Delete_Quotation, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const resData = await response.json();
                if (resData?.Status === 1 || resData?.Message === 'Success' || resData?.d === 'Success' || resData?.Success || resData?.d === true) {
                    Swal.fire({
                        title: 'Success',
                        text: 'cancelled updated successfully',
                        icon: 'success',
                        confirmButtonColor: '#28a745'
                    });
                    if (fetchQuotations) fetchQuotations();
                } else {
                    throw new Error(resData?.Details || resData?.Message || resData?.d || 'Failed to cancel quotation');
                }
            } else {
                throw new Error('Network response was not ok');
            }
        } catch (error) {
            console.error('Error cancelling quotation:', error);
            Swal.fire({
                title: 'Error',
                text: error.message || 'Failed to cancel quotation',
                icon: 'error',
                confirmButtonColor: '#ef4444'
            });
        }
    };

    const handleDeleteQuotation = async (quotation) => {
        const result = await Swal.fire({
            title: 'Delete Quotation',
            text: 'Are you sure you want to delete this quotation? This action cannot be undone.',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ef4444',
            cancelButtonColor: '#6e7881',
            confirmButtonText: 'Yes, delete it!'
        });

        if (!result.isConfirmed) return;

        try {
            const quotationId = quotation.QuoteId || quotation.QuotationId || quotation.ID || quotation.Id;
            const userId = localStorage.getItem('userId') || '34594';

            const payload = {
                Token: TOKEN,
                Details: {
                    QuoteIds: String(quotationId),
                    Mode: "Delete",
                    UserId: parseInt(userId, 10)
                }
            };

            const response = await fetch(Delete_Quotation, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const resData = await response.json();
                if (resData?.Status === 1 || resData?.Message === 'Success' || resData?.d === 'Success' || resData?.Success || resData?.d === true) {
                    Swal.fire({
                        title: 'Success',
                        text: 'Quotation deleted successfully.',
                        icon: 'success',
                        confirmButtonColor: '#28a745'
                    });
                    if (fetchQuotations) fetchQuotations();
                } else {
                    throw new Error(resData?.Details || resData?.Message || resData?.d || 'Failed to delete quotation');
                }
            } else {
                throw new Error('Network response was not ok');
            }
        } catch (error) {
            console.error('Error deleting quotation:', error);
            Swal.fire({
                title: 'Error',
                text: error.message || 'Failed to delete quotation',
                icon: 'error',
                confirmButtonColor: '#ef4444'
            });
        }
    };

    const handleRequestApproval = async (quotation) => {
        try {
            const quotationId = quotation.QuoteId || quotation.QuotationId || quotation.ID || quotation.Id;
            const userId = localStorage.getItem('userId') || '34594';

            const payload = {
                Token: "-2295521862261168",
                Details: {
                    UserId: parseInt(userId, 10),
                    EntityName: "Quotation",
                    EntityId: parseInt(quotationId, 10)
                }
            };

            const response = await fetch(SAVE_APPROVAL_URL, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const resData = await response.json();
                if (resData?.Status === 1 || resData?.Message === 'Success' || resData?.d === 'Success' || resData?.Success || resData?.d === true) {
                    Swal.fire({
                        title: 'Success',
                        text: 'Sent for approval successfully',
                        icon: 'success',
                        confirmButtonColor: '#28a745'
                    });
                    if (fetchQuotations) fetchQuotations();
                } else {
                    throw new Error(resData?.Details || resData?.Message || resData?.d || 'Failed to send for approval');
                }
            } else {
                throw new Error('Network response was not ok');
            }
        } catch (error) {
            console.error('Error requesting approval:', error);
            Swal.fire({
                title: 'Error',
                text: error.message || 'Failed to send for approval',
                icon: 'error',
                confirmButtonColor: '#ef4444'
            });
        }
    };

    const handleShowQuotation = async (quotation) => {
        setDetailLoading(true);
        setApproversInfo(null);
        setShowView({ _loading: true, _quotation: quotation });

        const quotationId = quotation.QuoteId || quotation.QuotationId || quotation.ID || quotation.Id;
        const status = (quotation.Status || "").toLowerCase();

        // Fetch Approvers Info if Sent for Approval
        if (status === 'sent for approval' || status === 'sent-for-approval') {
            fetchApproversInfo(quotationId);
        }

        try {
            const quotationId = quotation.QuoteId || quotation.QuotationId || quotation.ID || quotation.Id;
            const token = getToken();

            const payload = {
                Token: TOKEN || "-2295521862261168",
                Details: {
                    QuoteId: parseInt(quotationId, 10)
                }
            };

            const response = await fetch(Get_Quotation_Details, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const data = await response.json();
                const detail = data?.Details || data?.d;
                setShowView({ ...detail, _quotation: quotation, _targetEntityId: String(quotationId) });
            } else {
                setShowView({ _quotation: quotation, _fallback: true, _targetEntityId: String(quotationId) });
            }
        } catch (error) {
            console.error('Error fetching quotation details:', error);
            setShowView({ _quotation: quotation, _fallback: true });
        } finally {
            setDetailLoading(false);
        }
    };

    const fetchApproversInfo = async (entityId) => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const payload = {
                Token: "-2295521862261168",
                Details: {
                    UserId: parseInt(userId, 10),
                    EntityName: "Quotation",
                    EntityId: Number(entityId)
                }
            };

            const response = await fetch(Get_Approvers_Info, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const data = await response.json();
                const info = data?.Details || data?.Details || data?.d || data;
                setApproversInfo(info);
            }
        } catch (error) {
            console.error('Error fetching approvers info:', error);
        }
    };

    const handleApproveQuote = () => {
        setApprovalState({ open: true, status: 'Approved', remarks: '', loading: false });
    };

    const handleRejectQuote = () => {
        setApprovalState({ open: true, status: 'Rejected', remarks: '', loading: false });
    };

    const handleSaveApproval = async (directStatus = null, directRemark = null) => {
        try {
            const finalStatus = directStatus || approvalState.status;
            const finalRemark = directRemark !== null ? directRemark : approvalState.remarks;

            setApprovalState(prev => ({ ...prev, loading: true }));
            const userId = localStorage.getItem('userId') || '34594';

            // Get data from approversInfo or showView
            const approvalId = approversInfo?.Id || approversInfo?.ApprovalId ||
                (Array.isArray(approversInfo) ? (approversInfo[0]?.ApprovalId || approversInfo[0]?.ID || approversInfo[0]?.Id) : (approversInfo?.ID || approversInfo?.Id)) ||
                approversInfo?.ApprovalEntityId || '';

            const entityId = showView?._targetEntityId ||
                showView?._quotation?.QuoteId ||
                showView?._quotation?.QuotationId ||
                showView?._quotation?.ID ||
                showView?._quotation?.Id ||
                showView?.QuoteId ||
                showView?.QuotationId ||
                showView?.ID ||
                showView?.Id || '';

            const payload = {
                UserId: String(userId),
                invoiceApprovalData: {
                    ApprovalId: String(approvalId),
                    EntityId: String(entityId),
                    Status: finalStatus,
                    Remark: finalRemark,
                    IsActive: String(finalStatus).toLowerCase() === 'approved'
                }
            };

            const response = await fetch(Save_Approve_Data, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            const result = await response.json();
            const data = (result && typeof result === 'object' && 'd' in result) ? result.d : result;

            if (data === true || data === "true" || data === null || (data && data.Status === 1)) {
                // Fetch next approver immediately
                try {
                    const nextApproverPayload = {
                        Token: "-2295521862261168",
                        Details: {
                            UserId: parseInt(userId, 10),
                            EntityName: "Quotation",
                            EntityId: Number(entityId)
                        }
                    };
                    const nextResp = await fetch(Get_Approvers_Info, {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify(nextApproverPayload)
                    });
                    if (nextResp.ok) {
                        const nextData = await nextResp.json();
                        const nextInfo = nextData?.Details || nextData?.d || nextData;
                        setApproversInfo(nextInfo);
                    }
                } catch (nextErr) {
                    console.error('Error fetching next approver:', nextErr);
                }

                await Swal.fire({
                    title: 'Success',
                    text: `Quotation ${approvalState.status.toLowerCase()} successfully`,
                    icon: 'success',
                    confirmButtonColor: '#28a745',
                    timer: 2000
                });

                setApprovalState({ open: false, status: 'Approved', remarks: '', loading: false });
                
                // Update local status in view
                if (showView) {
                    const updatedView = { ...showView, Status: approvalState.status };
                    if (updatedView._quotation) {
                        updatedView._quotation.Status = approvalState.status;
                    }
                    setShowView(updatedView);
                }
                if (fetchQuotations) fetchQuotations();
            } else {
                throw new Error('Failed to update approval status');
            }
        } catch (error) {
            console.error('Error in handleSaveApproval:', error);
            Swal.fire({
                title: 'Error',
                text: error.message || 'Failed to update approval status',
                icon: 'error',
                confirmButtonColor: '#ef4444',
                target: document.querySelector('.invoice-detail-panel') || 'body',
                customClass: {
                    container: 'swal2-top-index'
                }
            });
        } finally {
            setApprovalState(prev => ({ ...prev, loading: false }));
        }
    };

    const handleSaveApprovalByStatus = async (status) => {
        let remark = '';
        if (status === 'Rejected') {
            const { value: text, isConfirmed } = await Swal.fire({
                title: 'Reject Quotation',
                input: 'textarea',
                inputLabel: 'Please provide a reason for rejection',
                inputPlaceholder: 'Type your remark here...',
                showCancelButton: true,
                confirmButtonText: 'Reject',
                confirmButtonColor: '#ef4444',
                target: document.querySelector('.invoice-detail-panel') || 'body'
            });
            if (!isConfirmed) return;
            remark = text || '';
        }
        handleSaveApproval(status, remark);
    };

    const renderApprovalModal = () => {
        if (!approvalState.open) return null;

        return (
            <div className="billtto-modal-overlay" onClick={() => setApprovalState({ open: false, status: 'Approved', remarks: '', loading: false })}>
                <div className="billtto-modal approval-modal" onClick={(e) => e.stopPropagation()}>
                    {approvalState.loading && (
                        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(255,255,255,0.7)', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <Loader message="Saving approval..." />
                        </div>
                    )}
                    <div className="billtto-modal-header">
                        <span>Approval/Rejection</span>
                        <button className="billtto-close-x" onClick={() => setApprovalState({ open: false, status: 'Approved', remarks: '', loading: false })}>&times;</button>
                    </div>
                    <div className="billtto-modal-body" style={{ padding: '20px 24px' }}>
                        <div className="approval-field-group">
                            <label className="approval-label">Status</label>
                            <select
                                className="approval-select"
                                value={approvalState.status}
                                onChange={(e) => setApprovalState(prev => ({ ...prev, status: e.target.value }))}
                            >
                                <option value="Approved">Approved</option>
                                <option value="Rejected">Rejected</option>
                            </select>
                        </div>

                        <div className="approval-field-group" style={{ marginTop: '20px' }}>
                            <label className="approval-label">Remarks</label>
                            <textarea
                                className="approval-remarks-area"
                                placeholder="Enter Description"
                                value={approvalState.remarks}
                                onChange={(e) => setApprovalState(prev => ({ ...prev, remarks: e.target.value }))}
                                rows={4}
                            />
                        </div>
                    </div>
                    <div className="modal-footer" style={{ borderTop: '1px solid #eee', padding: '15px 24px', display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                        <button
                            className="approval-close-btn"
                            onClick={() => setApprovalState({ open: false, status: 'Approved', remarks: '', loading: false })}
                            disabled={approvalState.loading}
                        >
                            Close
                        </button>
                        <button
                            className="approval-save-btn"
                            onClick={handleSaveApproval}
                            disabled={approvalState.loading}
                        >
                            {approvalState.loading ? 'Saving...' : 'Save'}
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    const handleGenerateInvoice = async () => {
        if (!showView || !showView._quotation) return;

        try {
            const quotationId = showView._quotation.QuoteId || showView._quotation.QuotationId || showView._quotation.ID || showView._quotation.Id;
            const userId = localStorage.getItem('userId') || '34594';
            const token = getToken();

            const payload = {
                Token: token,
                Details: {
                    QuotationIds: String(quotationId),
                    UserId: parseInt(userId, 10)
                }
            };

            const response = await fetch(Generate_Invoice, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const resData = await response.json();
                if (resData?.Status === 1 || resData?.Message === 'Success' || resData?.d === 'Success' || resData?.Success || resData?.d === true) {
                    Swal.fire({
                        title: 'Success',
                        text: 'Data Saved successfully.',
                        icon: 'success',
                        confirmButtonColor: '#28a745',
                        target: document.querySelector('.invoice-detail-panel') || 'body',
                        customClass: {
                            container: 'swal2-top-index'
                        }
                    });
                    setShowView(null);
                    if (fetchQuotations) fetchQuotations();
                } else {
                    throw new Error(resData?.Details || resData?.Message || resData?.d || 'Failed to generate invoice');
                }
            } else {
                throw new Error('Network response was not ok');
            }
        } catch (error) {
            console.error('Error generating invoice:', error);
            Swal.fire({
                title: 'Error',
                text: error.message || 'Failed to generate invoice',
                icon: 'error',
                confirmButtonColor: '#ef4444',
                target: document.querySelector('.invoice-detail-panel') || 'body',
                customClass: {
                    container: 'swal2-top-index'
                }
            });
        }
    };

    const handleEditQuotation = async (invoice, isDuplicate = false) => {
        setIsDuplicateMode(isDuplicate);
        setEditLoading(true);
        setCompanyOpen(false);
        setCustomerSearchOpen(false);
        setEditView({ _loading: true, _quotation: invoice });
        fetchOwners();
        fetchCurrencyList();

        try {
            const quotationId = invoice.QuotationId || invoice.ID || invoice.Id;
            const payload = {
                Token: TOKEN || "-2295521862261168",
                Details: {
                    QuoteId: parseInt(quotationId, 10)
                }
            };
            const response = await fetch(Get_Quotation_Details, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                const data = await response.json();
                const detail = data?.Details || data?.d;
                setEditView({ ...detail, _quotation: invoice });

                if (detail.CurrencyId) {
                    const matchedCurrency = currencyList.find(c => String(c.Id) === String(detail.CurrencyId));
                    if (matchedCurrency) {
                        setSelectedCurrency(matchedCurrency);
                    } else {
                        setSelectedCurrency({ Id: detail.CurrencyId, Symbol: detail.CurrencySymbol === 'Rp' ? '₹' : (detail.CurrencySymbol || '$'), Name: detail.CurrencyName || 'Dollars' });
                    }
                }

                let defaultQuotationDate = detail.QuotedAt || '';
                let defaultDueDate = detail.DueAt || '';
                
                if (isDuplicate) {
                    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                    const pad = (n) => n < 10 ? '0' + n : n;
                    const d1 = new Date();
                    defaultQuotationDate = `${pad(d1.getDate())}-${months[d1.getMonth()]}-${d1.getFullYear()}`;
                    // WebForms keeps the DueAt same as QuotedAt for duplicates (copies original)
                    defaultDueDate = defaultQuotationDate;
                }

                setEditForm({
                    title: detail.Title || 'Quotation',
                    subheading: detail.SubHeading || '',
                    placeOfSupply: detail.PlaceOfSupply || detail.CompanySupplyName || detail.ShipToState || detail.BillToState || '',
                    placeOfOrigin: (['Berat', '1'].includes(detail.PlaceOfOrigin || detail.CompanyOriginName || detail.CompanyState || detail.BillToState) ? 'India' : (detail.PlaceOfOrigin || detail.CompanyOriginName || detail.CompanyState || detail.BillToState || '')),
                    salesOwner: detail.SalesOwner || '',
                    quotationNumber: isDuplicate ? '' : (detail.QuoteNumber || ''), // Will be filled by fetchCompanySettings if duplicate
                    quotationDate: defaultQuotationDate,
                    dueDate: defaultDueDate,
                    termsCondition: detail.CompanyTermCondition || '',
                    notes: detail.Notes || '',
                    footer: detail.Footer || '',
                });

                if (isDuplicate) {
                    fetchCompanySettings(true, detail.QuoteNumber);
                }

                const ld = detail.leadDetail || {};
                // Use BillTo-specific IDs from the API (the primary source), fall back to generic lead IDs
                const countryId = detail.BillToCountryId || detail.CountryId || detail.countryid || ld.CountryId || ld.countryid || '';
                const stateId = detail.BillToStateId || detail.StateId || detail.stateid || ld.StateId || ld.stateid || '';
                const cityId = detail.BillToCityId || detail.CityId || detail.cityid || ld.CityId || ld.cityid || '';

                const bf = {
                    company: detail.BillToCompanyName || ld.CompanyName || '',
                    name: detail.ContactName || ld.PersonName || '',
                    email: detail.ContactEmail || ld.EmailID || '',
                    phone: detail.ContactPhone || ld.MobileNo || '',
                    taxNumber: (detail.ContactTaxNumber || ld.TaxNumber || '').trim(),
                    panNumber: (detail.ContactPanNumber || ld.PanNumber || '').trim(),
                    address: detail.ContactAddress || ld.Address || '',
                    countryId: countryId,
                    countryName: detail.BillToCountry || detail.ContactCountry || ld.Country || '',
                    stateId: stateId,
                    stateName: detail.BillToState || detail.ContactState || ld.State || '',
                    cityId: cityId,
                    cityName: detail.BillToCity || detail.ContactCity || ld.City || '',
                    pincode: (detail.BillToPincode !== undefined && detail.BillToPincode !== null && detail.BillToPincode !== "") ? String(detail.BillToPincode) : (detail.ContactPincode || detail.Pincode || ld.PinCode || ''),
                    leadTax: '',
                };
                setBillToForm(bf);

                const sf = {
                    company: detail.ShipToCompanyName || ld.CompanyName || '',
                    name: detail.ShipToName || detail.ContactName || ld.PersonName || '',
                    email: detail.ShipToEmailId || detail.ContactEmail || ld.EmailID || '',
                    phone: detail.ShipToPhone || detail.ContactPhone || ld.MobileNo || '',
                    address: detail.ShipToAddress || detail.ContactAddress || ld.Address || '',
                    countryId: detail.ShipToCountryId || detail.countryid || countryId || '',
                    countryName: detail.ShipToCountry || detail.BillToCountry || ld.Country || '',
                    stateId: detail.ShipToStateId || detail.stateid || stateId || '',
                    stateName: detail.ShipToState || detail.BillToState || ld.State || '',
                    cityId: detail.ShipToCityId || detail.cityid || cityId || '',
                    cityName: detail.ShipToCity || detail.BillToCity || ld.City || '',
                    pincode: (detail.ShipToPincode !== undefined && detail.ShipToPincode !== null && detail.ShipToPincode !== "") ? String(detail.ShipToPincode) : (detail.BillToPincode || detail.ContactPincode || detail.Pincode || ld.PinCode || ''),
                };
                setShipToForm(sf);

                // Determine if shipTo is same as billTo
                const isSame = (detail.ShipToName || detail.ContactName) === (detail.ContactName || ld.PersonName) &&
                    (detail.ShipToAddress || detail.ContactAddress) === (detail.ContactAddress || ld.Address) &&
                    (detail.ShipToCityId || detail.CityId) === (detail.CityId || ld.CityId);
                setIsSameAsBillTo(isSame);
            } else {
                setEditView({ _quotation: invoice, _fallback: true });
            }
        } catch (error) {
            console.error('Error fetching quotation for edit:', error);
            setEditView({ _quotation: invoice, _fallback: true });
        } finally {
            setEditLoading(false);
        }
    };

    const handleAddQuotation = (leadIdStr = null) => {
        setIsDuplicateMode(false); // Fixed: Should be false for a new quotation
        setEditLoading(false);
        setCompanyOpen(false);
        setCustomerSearchOpen(false);

        // Signal a new add flow
        setEditView({ _isAdd: true });

        fetchOwners();
        fetchCurrencyList();
        fetchCompanySettings();

        const today = new Date();
        const tenDaysLater = new Date();
        tenDaysLater.setDate(today.getDate() + 10);

        // Reset Forms to defaults (and trigger fetch for new quotation number explicitly)
        setEditForm({
            title: 'Quotation',
            subheading: '',
            placeOfSupply: '',
            placeOfOrigin: 'India',
            salesOwner: '',
            quotationNumber: '',
            quotationDate: formatDate(today),
            dueDate: formatDate(tenDaysLater),
            termsCondition: '',
            notes: '',
            footer: ''
        });

        const num = generateAddQuotationNumber();
        if (num) {
            setEditForm(prev => ({ ...prev, quotationNumber: num }));
        }

        setBillToForm({
            name: '', email: '', phone: '', address: '', countryId: '', countryName: '', stateId: '', stateName: '', cityId: '', cityName: '', pincode: '', taxNumber: '', panNumber: '', leadTax: ''
        });
        setShipToForm({
            name: '', email: '', phone: '', address: '', countryId: '', countryName: '', stateId: '', stateName: '', cityId: '', cityName: '', pincode: ''
        });
        setIsSameAsBillTo(true);
        setAddedItems([]);
        setAddedCharges([]);
        setItemDiscounts({});
        setItemAddedTaxes({});

        // Automatically open customer search for a new invoice
        setCustomerSearchOpen(true);
        setCustomerSearchText('');
        setCustomerSuggestions([]);
    };

    const fetchPlaceholders = async () => {
        try {
            const userId = localStorage.getItem('userId') || '34594';
            const response = await fetch(Choose_Placeholder, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ Token: "-2295521862261168", Details: { UserId: parseInt(userId, 10) } })
            });
            if (response.ok) {
                const data = await response.json();
                const list = data?.Details || data?.Details || data?.d || data?.Data || data?.data || data || [];
                setPlaceholderOptions(Array.isArray(list) ? list : (list.placeholders || []));
            }
        } catch (err) {
            console.error('Error fetching placeholders:', err);
        }
    };

    const handleInsertPlaceholder = (tag) => {
        if (!quillRef.current) return;
        const editor = quillRef.current.getEditor();
        const selection = editor.getSelection();
        const cursorPosition = selection ? selection.index : editor.getLength();
        editor.insertText(cursorPosition, `#${tag}#\n`);
        setPlaceholderModalOpen(false);
    };

    // ─── Render: Item Entity Modal ────────────────────────────────────────────
    const renderItemEntityModal = () => {
        if (!itemEntityModal.open) return null;
        return (
            <div className="billtto-modal-overlay" style={{ paddingTop: '80px' }}>
                <div className="billtto-modal" style={{ height: 'auto' }}>
                    <div className="billtto-modal-header">
                        <span>Edit Item Entity</span>
                        <button className="billtto-close-x" onClick={() => setItemEntityModal({ open: false, index: -1, value: '' })}>×</button>
                    </div>
                    <div className="billtto-modal-body">
                        <div className="billtto-field-group">
                            <input
                                className="billtto-input"
                                style={{ width: '100%', padding: '10px', border: '1px solid #3b82f6', borderRadius: '4px', outline: 'none' }}
                                value={itemEntityModal.value}
                                onChange={e => setItemEntityModal(prev => ({ ...prev, value: e.target.value }))}
                            />
                        </div>
                    </div>
                    <div className="billtto-modal-footer" style={{ justifyContent: 'flex-end', gap: '10px' }}>
                        <button className="billtto-btn-close" onClick={() => setItemEntityModal({ open: false, index: -1, value: '' })}>Cancel</button>
                        <button className="billtto-btn-apply" onClick={() => {
                            handleApplyItemEdit(itemEntityModal.index, 'Name', itemEntityModal.value);
                            setItemEntityModal({ open: false, index: -1, value: '' });
                        }}>Apply</button>
                    </div>
                </div>
            </div>
        );
    };

    // ─── Render: Item Description Modal ───────────────────────────────────────
    const renderItemDescriptionModal = () => {
        if (!itemDescModal.open) return null;

        const descQuillModules = {
            toolbar: [['bold', 'italic', 'underline']]
        };

        return (
            <div className="billtto-modal-overlay" style={{ paddingTop: '60px' }}>
                <div className="billtto-modal" style={{ width: '600px', height: 'auto' }}>
                    <div className="billtto-modal-header">
                        <span>Edit Item Description</span>
                        <button className="billtto-close-x" onClick={() => setItemDescModal({ open: false, index: -1, value: '', type: 'existing' })}>×</button>
                    </div>
                    <div className="billtto-modal-body" style={{ position: 'relative' }}>
                        <div className="item-description-editor-container">
                             <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '5px' }}>
                                <button 
                                    type="button" 
                                    className="billtto-btn-placeholder"
                                    style={{ 
                                        display: 'flex', alignItems: 'center', gap: '5px', 
                                        padding: '4px 8px', fontSize: '12px', background: '#f8fafc',
                                        border: '1px solid #e2e8f0', borderRadius: '4px', cursor: 'pointer'
                                    }}
                                    onClick={() => { fetchPlaceholders(); setPlaceholderModalOpen(true); }}
                                >
                                    <Settings size={14} /> Placeholder
                                </button>
                            </div>
                            <SafeQuill
                                ref={quillRef}
                                theme="snow"
                                value={itemDescModal.value}
                                onChange={(val) => setItemDescModal(prev => ({ ...prev, value: val }))}
                                modules={descQuillModules}
                                placeholder="Description"
                            />
                        </div>

                        {placeholderModalOpen && (
                            <div className="placeholder-mini-modal" style={{
                                position: 'absolute', top: '40px', right: '20px', zIndex: 100,
                                background: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px',
                                boxShadow: '0 4px 12px rgba(0,0,0,0.1)', width: '280px'
                            }}>
                                <div style={{ 
                                    padding: '8px 12px', borderBottom: '1px solid #f1f5f9', 
                                    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                                    background: '#f8fafc', borderTopLeftRadius: '8px', borderTopRightRadius: '8px'
                                }}>
                                    <span style={{ fontSize: '11px', fontWeight: 600, color: '#64748b', letterSpacing: '0.05em' }}>CHOOSE YOUR PLACEHOLDER</span>
                                    <button onClick={() => setPlaceholderModalOpen(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: '16px', color: '#94a3b8' }}>×</button>
                                </div>
                                <div style={{ padding: '15px' }}>
                                    <select 
                                        style={{ width: '100%', padding: '8px', borderRadius: '4px', border: '1px solid #d1d5db', fontSize: '13px', outline: 'none' }}
                                        onChange={(e) => {
                                            if (e.target.value) handleInsertPlaceholder(e.target.value);
                                        }}
                                        value=""
                                    >
                                        <option value="" disabled>--Select Entity Placeholder--</option>
                                        {placeholderOptions.map((opt, i) => {
                                            const val = opt.Text || opt.Name || opt.TagName || opt.Value || (typeof opt === 'string' ? opt : '');
                                            if (!val) return null;
                                            return (
                                                <option key={i} value={val}>
                                                    {val}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                        )}

                        {previewOptions.length > 0 && (
                            <div className="preview-suggestions">
                                <div className="suggestion-label">SUGGESTIONS:</div>
                                <div className="suggestion-list-wrapper">
                                    {previewOptions.slice(0, 5).map((opt, idx) => (
                                        <div key={idx} className="suggestion-item" onClick={() => setItemDescModal(prev => ({ ...prev, value: opt.Text || opt.Name || '' }))}>
                                            {opt.Text || opt.Name}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="billtto-modal-footer" style={{ justifyContent: 'flex-end', gap: '10px' }}>
                        <button className="billtto-btn-close" onClick={() => setItemDescModal({ open: false, index: -1, value: '', type: 'existing' })}>Cancel</button>
                        <button className="billtto-btn-apply" onClick={() => {
                            handleApplyItemEdit(itemDescModal.index, 'Description', itemDescModal.value, itemDescModal.type);
                            setItemDescModal({ open: false, index: -1, value: '', type: 'existing' });
                        }}>Apply</button>
                    </div>
                </div>
            </div>
        );
    };

    // ─── Render: Bill To Edit Modal ───────────────────────────────────────────
    const renderBillToModal = () => {
        if (!billToOpen) return null;
        const bf = billToForm;
        const upd = (key, val) => setBillToForm(prev => ({ ...prev, [key]: val }));

        const handleCountryChange = (e) => {
            const val = e.target.value;
            const opt = countryOptions.find(o => String(o.Id || o.Code || o.Value || o.countryid || '') === val);
            upd('countryId', val);
            upd('countryName', opt?.Text || opt?.Name || opt?.Name1 || opt?.Value || '');
            upd('stateId', ''); upd('stateName', '');
            upd('cityId', ''); upd('cityName', '');
            if (val) fetchStates(val);
        };
        const handleStateChange = (e) => {
            const val = e.target.value;
            const opt = stateOptions.find(o => String(o.Id || o.Code || o.Value || o.stateid || '') === val);
            upd('stateId', val);
            upd('stateName', opt?.Text || opt?.Name || opt?.Name1 || opt?.Value || '');
            upd('cityId', ''); upd('cityName', '');
            if (val) fetchCities(val);
        };
        const handleCityChange = (e) => {
            const val = e.target.value;
            const opt = cityOptions.find(o => String(o.Id || o.Code || o.Value || o.cityid || '') === val);
            upd('cityId', val);
            upd('cityName', opt?.Text || opt?.Name || opt?.Name1 || opt?.Value || '');
        };

        return (
            <div className="billtto-modal-overlay" onClick={() => setBillToOpen(false)}>
                <div className="billtto-modal" onClick={e => e.stopPropagation()}>
                    <div className="billtto-modal-header">
                        <span>Edit your lead address</span>
                        <button className="billtto-close-x" onClick={() => setBillToOpen(false)}>×</button>
                    </div>
                    <div className="billtto-modal-body">
                        {/* Lead Tax */}
                        <div className="billtto-field-group">
                            <label>Lead Tax</label>
                            <div className="billtto-select-wrap">
                                <span className="billtto-icon">☰</span>
                                <select
                                    value={bf.leadTax || ''}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        upd('leadTax', val);
                                        const selected = leadTaxOptions.find(o => String(o.Id || o.Code || o.Value || '') === val);
                                        if (selected) {
                                            const taxNum = (selected.TaxNumber || '').trim();
                                            upd('taxNumber', taxNum);
                                            if (selected.Address) upd('address', selected.Address);
                                            if (selected.Pincode) upd('pincode', selected.Pincode);
                                            
                                            if (selected.CountryId) {
                                                upd('countryId', selected.CountryId);
                                                const cOpt = countryOptions.find(o => String(o.Id || o.Code || o.Value || o.countryid || '') === String(selected.CountryId));
                                                if (cOpt) upd('countryName', cOpt.Text || cOpt.Name || '');
                                                fetchStates(selected.CountryId);
                                            }
                                            if (selected.StateId) {
                                                upd('stateId', selected.StateId);
                                                // We might not have stateOptions loaded yet if fetchStates was just called
                                                // but if we do, let's update the name
                                                const sOpt = stateOptions.find(o => String(o.Id || o.Code || o.Value || o.stateid || '') === String(selected.StateId));
                                                if (sOpt) upd('stateName', sOpt.Text || sOpt.Name || '');
                                                fetchCities(selected.StateId);
                                            }
                                            if (selected.CityId) {
                                                upd('cityId', selected.CityId);
                                                const ctOpt = cityOptions.find(o => String(o.Id || o.Code || o.Value || o.cityid || '') === String(selected.CityId));
                                                if (ctOpt) upd('cityName', ctOpt.Text || ctOpt.Name || '');
                                            }
                                        }
                                    }}
                                    className="billtto-select"
                                >
                                    <option value="">Nothing selected</option>
                                    {leadTaxOptions.map((o, i) => (
                                        <option key={i} value={o.Id || o.Code || o.Value || ''}>
                                            {o.TaxNumber || o.Text || o.Name || o.Name1 || o.Value || String(i)}
                                        </option>
                                    ))}
                                </select>
                                <span className="billtto-arrow">▼</span>
                            </div>
                        </div>

                        {/* Name + Tax Number */}
                        <div className="billtto-row-2">
                            <div className="billtto-field-group">
                                <label>Name</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">👤</span>
                                    <input placeholder="Name" value={bf.name || ''} onChange={e => upd('name', e.target.value)} />
                                </div>
                            </div>
                            <div className="billtto-field-group">
                                <label>Tax Number</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">%</span>
                                    <input placeholder="Tax Number" value={bf.taxNumber || ''} readOnly style={{ backgroundColor: '#f8fafc', cursor: 'not-allowed' }} />
                                </div>
                            </div>
                        </div>

                        {/* Email + Phone */}
                        <div className="billtto-row-2">
                            <div className="billtto-field-group">
                                <label>Email</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">✉</span>
                                    <input placeholder="Enter Email" value={bf.email || ''} onChange={e => upd('email', e.target.value)} />
                                </div>
                            </div>
                            <div className="billtto-field-group">
                                <label>Phone</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">📞</span>
                                    <input placeholder="Phone" value={bf.phone || ''} onChange={e => upd('phone', e.target.value)} />
                                </div>
                            </div>
                        </div>

                        {/* Country */}
                        <div className="billtto-field-group">
                            <label>Country</label>
                            <div className="billtto-select-wrap">
                                <span className="billtto-icon">🌐</span>
                                <select value={bf.countryId || ''} onChange={handleCountryChange} className="billtto-select" style={{ color: '#334155' }}>
                                    <option value="">--- Select Country ---</option>
                                    {countryOptions.map((o, i) => (
                                        <option key={i} value={o.Id || o.Code || o.Value || o.countryid || ''}>
                                            {o.Text || o.Name || o.Name1 || o.Value || o.countryname || ''}
                                        </option>
                                    ))}
                                </select>
                                <span className="billtto-arrow">▼</span>
                            </div>
                        </div>

                        {/* State + City */}
                        <div className="billtto-row-2">
                            <div className="billtto-field-group">
                                <label>State</label>
                                <div className="billtto-select-wrap">
                                    <span className="billtto-icon">🌐</span>
                                    <select value={bf.stateId || ''} onChange={handleStateChange} className="billtto-select" style={{ color: '#334155' }}>
                                        <option value="">--- Select State ---</option>
                                        {stateOptions.map((o, i) => (
                                            <option key={i} value={o.Id || o.Code || o.Value || o.stateid || ''}>
                                                {o.Text || o.Name || o.Name1 || o.Value || o.statename || ''}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="billtto-arrow">▼</span>
                                </div>
                            </div>
                            <div className="billtto-field-group">
                                <label>City</label>
                                <div className="billtto-select-wrap">
                                    <span className="billtto-icon">🌐</span>
                                    <select value={bf.cityId || ''} onChange={handleCityChange} className="billtto-select" style={{ color: '#334155' }}>
                                        <option value="">--- Select City ---</option>
                                        {cityOptions.map((o, i) => (
                                            <option key={i} value={o.Id || o.Code || o.Value || o.cityid || ''}>
                                                {o.Text || o.Name || o.Name1 || o.Value || o.cityname || ''}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="billtto-arrow">▼</span>
                                </div>
                            </div>
                        </div>

                        {/* Pincode + Pan Number */}
                        <div className="billtto-row-2">
                            <div className="billtto-field-group">
                                <label>Pincode</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">🌐</span>
                                    <input placeholder="Enter Pincode" value={bf.pincode || ''} onChange={e => upd('pincode', e.target.value)} />
                                </div>
                            </div>
                            <div className="billtto-field-group">
                                <label>Pan Number</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">🌐</span>
                                    <input placeholder="Enter Pan Number" value={bf.panNumber || ''} onChange={e => upd('panNumber', e.target.value)} />
                                </div>
                            </div>
                        </div>

                        {/* Address */}
                        <div className="billtto-field-group">
                            <label>Address</label>
                            <textarea className="billtto-textarea" placeholder="Address" value={bf.address || ''} onChange={e => upd('address', e.target.value)} rows={3} />
                        </div>
                    </div>

                    <div className="billtto-modal-footer">
                        <button className="billtto-btn-close" onClick={() => setBillToOpen(false)}>Close</button>
                        <button className="billtto-btn-apply" onClick={() => {
                            if (billToForm.stateName) {
                                setEditForm(prev => ({ ...prev, placeOfSupply: billToForm.stateName }));
                            }
                            setBillToOpen(false);
                        }}>Apply</button>
                    </div>
                </div>
            </div>
        );
    };

    // ─── Render: Ship To Edit Modal ───────────────────────────────────────────
    const renderShipToModal = () => {
        if (!shipToOpen) return null;
        const sf = shipToForm;
        const upd = (key, val) => setShipToForm(prev => ({ ...prev, [key]: val }));

        const handleCountryChange = (e) => {
            const val = e.target.value;
            const opt = countryOptions.find(o => String(o.Id || o.Code || o.Value || o.countryid || '') === val);
            upd('countryId', val);
            upd('countryName', opt?.Text || opt?.Name || opt?.Name1 || opt?.Value || '');
            upd('stateId', ''); upd('stateName', '');
            upd('cityId', ''); upd('cityName', '');
            if (val) fetchStates(val);
        };
        const handleStateChange = (e) => {
            const val = e.target.value;
            const opt = stateOptions.find(o => String(o.Id || o.Code || o.Value || o.stateid || '') === val);
            upd('stateId', val);
            upd('stateName', opt?.Text || opt?.Name || opt?.Name1 || opt?.Value || '');
            upd('cityId', ''); upd('cityName', '');
            if (val) fetchCities(val);
        };
        const handleCityChange = (e) => {
            const val = e.target.value;
            const opt = cityOptions.find(o => String(o.Id || o.Code || o.Value || o.cityid || '') === val);
            upd('cityId', val);
            upd('cityName', opt?.Text || opt?.Name || opt?.Name1 || opt?.Value || '');
        };

        return (
            <div className="billtto-modal-overlay" onClick={() => setShipToOpen(false)}>
                <div className="billtto-modal" onClick={e => e.stopPropagation()}>
                    <div className="billtto-modal-header">
                        <span>Edit ShipTo</span>
                        <button className="billtto-close-x" onClick={() => setShipToOpen(false)}>×</button>
                    </div>
                    <div className="billtto-modal-body">
                        {/* Name + Email */}
                        <div className="billtto-row-2">
                            <div className="billtto-field-group">
                                <label>Name</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">👤</span>
                                    <input placeholder="Name" value={sf.name || ''} onChange={e => upd('name', e.target.value)} />
                                </div>
                            </div>
                            <div className="billtto-field-group">
                                <label>Email</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">✉</span>
                                    <input placeholder="Enter Email" value={sf.email || ''} onChange={e => upd('email', e.target.value)} />
                                </div>
                            </div>
                        </div>

                        {/* Phone + Country */}
                        <div className="billtto-row-2">
                            <div className="billtto-field-group">
                                <label>Phone</label>
                                <div className="billtto-input-wrap">
                                    <span className="billtto-icon">📞</span>
                                    <input placeholder="Phone" value={sf.phone || ''} onChange={e => upd('phone', e.target.value)} />
                                </div>
                            </div>
                            <div className="billtto-field-group">
                                <label>Country</label>
                                <div className="billtto-select-wrap">
                                    <span className="billtto-icon">🌐</span>
                                    <select value={sf.countryId || ''} onChange={handleCountryChange} className="billtto-select" style={{ color: '#334155' }}>
                                        <option value="">Nothing selected</option>
                                        {countryOptions.map((o, i) => (
                                            <option key={i} value={o.Id || o.Code || o.Value || o.countryid || ''}>
                                                {o.Text || o.Name || o.Name1 || o.Value || o.countryname || ''}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="billtto-arrow">▼</span>
                                </div>
                            </div>
                        </div>

                        {/* State + City */}
                        <div className="billtto-row-2">
                            <div className="billtto-field-group">
                                <label>State</label>
                                <div className="billtto-select-wrap">
                                    <span className="billtto-icon">🌐</span>
                                    <select value={sf.stateId || ''} onChange={handleStateChange} className="billtto-select" style={{ color: '#334155' }}>
                                        <option value="">Nothing selected</option>
                                        {stateOptions.map((o, i) => (
                                            <option key={i} value={o.Id || o.Code || o.Value || o.stateid || ''}>
                                                {o.Text || o.Name || o.Name1 || o.Value || o.statename || ''}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="billtto-arrow">▼</span>
                                </div>
                            </div>
                            <div className="billtto-field-group">
                                <label>City</label>
                                <div className="billtto-select-wrap">
                                    <span className="billtto-icon">🌐</span>
                                    <select value={sf.cityId || ''} onChange={handleCityChange} className="billtto-select" style={{ color: '#334155' }}>
                                        <option value="">Nothing selected</option>
                                        {cityOptions.map((o, i) => (
                                            <option key={i} value={o.Id || o.Code || o.Value || o.cityid || ''}>
                                                {o.Text || o.Name || o.Name1 || o.Value || o.cityname || ''}
                                            </option>
                                        ))}
                                    </select>
                                    <span className="billtto-arrow">▼</span>
                                </div>
                            </div>
                        </div>

                        {/* Pincode */}
                        <div className="billtto-field-group">
                            <label>Pincode</label>
                            <div className="billtto-input-wrap" style={{ width: '50%' }}>
                                <span className="billtto-icon">🌐</span>
                                <input placeholder="Enter Pincode" value={sf.pincode || ''} onChange={e => upd('pincode', e.target.value)} />
                            </div>
                        </div>

                        {/* Address */}
                        <div className="billtto-field-group">
                            <label>Address</label>
                            <textarea className="billtto-textarea" placeholder="Address" value={sf.address || ''} onChange={e => upd('address', e.target.value)} rows={3} />
                        </div>
                    </div>

                    <div className="billtto-modal-footer">
                        <button className="billtto-btn-close" onClick={() => setShipToOpen(false)}>Close</button>
                        <button className="billtto-btn-apply" style={{ background: '#84cc16' }} onClick={() => {
                            if (sf.stateName) {
                                setEditForm(prev => ({
                                    ...prev,
                                    placeOfSupply: sf.stateName
                                }));
                            }
                            Swal.fire({
                                title: 'Success',
                                text: 'Shipped address updated',
                                icon: 'success',
                                confirmButtonColor: '#16a34a'
                            });
                            setShipToOpen(false);
                        }}>Save</button>
                    </div>
                </div>
            </div>
        );
    };

    const renderProductAddDrawer = () => {
        if (!isProductAddOpen) return null;
        const pf = productForm;
        const upd = (key, val) => setProductForm(prev => ({ ...prev, [key]: val }));

        const addVariantRow = () => setVariantRows([...variantRows, { id: Date.now(), name: '', values: '' }]);
        const removeVariantRow = (id) => setVariantRows(variantRows.filter(r => r.id !== id));
        const updVariantRow = (id, key, val) => setVariantRows(variantRows.map(r => r.id === id ? { ...r, [key]: val } : r));

        const handleCreateCombination = () => {
            setIsCombinationCreated(true);
            // Logic to generate combinations based on variantRows would go here
        };

        return (
            <>
                <AddProductForm
                    onClose={() => setIsProductAddOpen(false)}
                    onSuccess={(prod) => handleSelectItem(prod)}
                    source="Quotation"
                />
                {false && (
                    <div className="product-add-overlay" onClick={() => setIsProductAddOpen(false)}>
                        <div className="product-add-panel restructured" onClick={e => e.stopPropagation()}>
                            <div className="product-add-header">
                                <span>New Product</span>
                                <button className="billtto-close-x" onClick={() => setIsProductAddOpen(false)}>×</button>
                            </div>
                            <div className="product-add-body">
                                {/* Basic Section */}
                                <div className="product-form-section-modern">
                                    <div className="section-header-modern">
                                        <span>Basic</span>
                                        <div className="header-actions">
                                            <label className="checkbox-label-modern">
                                                <input type="checkbox" checked={pf.isCatalogue} onChange={e => upd('isCatalogue', e.target.checked)} />
                                                <span>Catalogue</span>
                                            </label>
                                        </div>
                                    </div>
                                    <div className="section-content-modern">
                                        <div className="product-type-radio-group">
                                            <label className="radio-label-modern">
                                                <input type="radio" name="prodType" checked={pf.isGoods} onChange={() => setProductForm(prev => ({ ...prev, isGoods: true, isServices: false }))} />
                                                <span className="radio-custom"></span>
                                                <span>Goods</span>
                                            </label>
                                            <label className="radio-label-modern">
                                                <input type="radio" name="prodType" checked={pf.isServices} onChange={() => setProductForm(prev => ({ ...prev, isGoods: false, isServices: true }))} />
                                                <span className="radio-custom"></span>
                                                <span>Services</span>
                                            </label>
                                        </div>

                                        <div className="form-row-modern">
                                            <div className="form-group-modern">
                                                <label>Name <span className="required">*</span></label>
                                                <div className="input-with-icon-modern">
                                                    <User size={16} className="input-icon" />
                                                    <input placeholder="Enter Name" value={pf.productName} onChange={e => upd('productName', e.target.value)} />
                                                </div>
                                            </div>
                                            <div className="form-group-modern">
                                                <label>SKU <span className="required">*</span></label>
                                                <div className="input-with-icon-modern">
                                                    <BoxIcon size={16} className="input-icon" />
                                                    <input placeholder="Enter SKU" value={pf.sku} onChange={e => upd('sku', e.target.value)} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-row-modern">
                                            <div className="form-group-modern">
                                                <label>Unit <span className="required">*</span></label>
                                                <div className="input-with-action-modern">
                                                    <div className="input-with-icon-modern flex-grow">
                                                        <List size={16} className="input-icon" />
                                                        <select value={pf.unitId} onChange={e => upd('unitId', e.target.value)}>
                                                            <option value="">Select Unit</option>
                                                            {(productOptions?.units || []).map(u => <option key={u.Id} value={u.Id}>{u.UnitName || u.Name}</option>)}
                                                        </select>
                                                    </div>
                                                    <button className="add-action-btn-modern">+ Add Unit</button>
                                                </div>
                                            </div>
                                            {!pf.isCatalogue && (
                                                <div className="form-group-modern">
                                                    <label>HSN Code <span className="required">*</span></label>
                                                    <div className="input-with-action-modern">
                                                        <div className="input-with-icon-modern flex-grow">
                                                            <Hash size={16} className="input-icon" />
                                                            <input placeholder="Enter HSN" value={pf.hsnCode} onChange={e => upd('hsnCode', e.target.value)} />
                                                        </div>
                                                        <button className="add-action-btn-modern hsn-search-btn" onClick={() => window.open('https://cbic-gst.gov.in/gst-goods-services-rates.html', '_blank')}>
                                                            <Search size={14} /> Search
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* Taxes Section */}
                                <div className="product-form-section-modern">
                                    <div className="section-header-modern">Taxes</div>
                                    <div className="section-content-modern">
                                        <div className="form-group-modern">
                                            <label>Tax</label>
                                            <div className="product-type-radio-group">
                                                <label className="radio-label-modern">
                                                    <input type="radio" name="taxType" checked={pf.isTaxable} onChange={() => upd('isTaxable', true)} />
                                                    <span className="radio-custom"></span>
                                                    <span>Taxable</span>
                                                </label>
                                                <label className="radio-label-modern">
                                                    <input type="radio" name="taxType" checked={!pf.isTaxable} onChange={() => upd('isTaxable', false)} />
                                                    <span className="radio-custom"></span>
                                                    <span>Non Taxable</span>
                                                </label>
                                            </div>
                                        </div>

                                        {pf.isTaxable && (
                                            <>
                                                <div className="form-group-modern sub-label-group">
                                                    <label className="sub-section-title">Default Tax</label>
                                                    <div className="form-group-modern">
                                                        <label>Home State Tax</label>
                                                        <div className="tax-tags-container-modern">
                                                            <select value={pf.homeStateTaxIds} onChange={e => upd('homeStateTaxIds', e.target.value)}>
                                                                <option value="">Select Tax</option>
                                                                {(productOptions?.taxes || []).map(t => <option key={t.Id} value={t.Id}>{t.Name} ({t.Rate}%)</option>)}
                                                            </select>
                                                            {pf.homeStateTaxIds && (
                                                                <div className="tax-tag-modern">
                                                                    <span>{productOptions?.taxes?.find(t => String(t.Id) === String(pf.homeStateTaxIds))?.Name} (0%)</span>
                                                                    <X size={12} onClick={() => upd('homeStateTaxIds', '')} />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                    <div className="form-group-modern">
                                                        <label>Others Home State Tax</label>
                                                        <div className="tax-tags-container-modern">
                                                            <select value={pf.otherTaxIds} onChange={e => upd('otherTaxIds', e.target.value)}>
                                                                <option value="">Select Tax</option>
                                                                {(productOptions?.taxes || []).map(t => <option key={t.Id} value={t.Id}>{t.Name} ({t.Rate}%)</option>)}
                                                            </select>
                                                            {pf.otherTaxIds && (
                                                                <div className="tax-tag-modern">
                                                                    <span>{productOptions?.taxes?.find(t => String(t.Id) === String(pf.otherTaxIds))?.Name} (0%)</span>
                                                                    <X size={12} onClick={() => upd('otherTaxIds', '')} />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>

                                {/* Sales Section */}
                                <div className="product-form-section-modern">
                                    <div className="section-header-modern">Sales</div>
                                    <div className="section-content-modern">
                                        <label className="checkbox-label-modern mb-16">
                                            <input type="checkbox" checked={pf.isSaleable} onChange={e => upd('isSaleable', e.target.checked)} />
                                            <span>Is Saleable</span>
                                        </label>
                                        {pf.isSaleable && (
                                            <div className="form-row-modern">
                                                <div className="form-group-modern">
                                                    <label>Sales Price <span className="required">*</span></label>
                                                    <div className="input-with-icon-modern">
                                                        <Percent size={16} className="input-icon" />
                                                        <input type="number" placeholder="Enter Sales Price" value={pf.salesPrice} onChange={e => upd('salesPrice', parseFloat(e.target.value) || 0)} />
                                                    </div>
                                                </div>
                                                <div className="form-group-modern">
                                                    <label>Cost Price <span className="required">*</span></label>
                                                    <div className="input-with-icon-modern">
                                                        <Percent size={16} className="input-icon" />
                                                        <input type="number" placeholder="Enter Cost Price" value={pf.costPrice} onChange={e => upd('costPrice', parseFloat(e.target.value) || 0)} />
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Variant Section */}
                                <div className="product-form-section-modern">
                                    <div className="section-header-modern">Variant</div>
                                    <div className="section-content-modern">
                                        <label className="checkbox-label-modern mb-16">
                                            <input type="checkbox" checked={pf.hasVariants} onChange={e => upd('hasVariants', e.target.checked)} />
                                            <span>This product has variants</span>
                                        </label>
                                        {pf.hasVariants && (
                                            <div className="variant-management-modern">
                                                <div className="variant-row-container">
                                                    {variantRows.map((row) => (
                                                        <div key={row.id} className="variant-row-modern">
                                                            <div className="form-group-modern">
                                                                {variantRows.indexOf(row) === 0 && <label>Variants</label>}
                                                                <div className="variant-inputs-grid">
                                                                    <input 
                                                                        placeholder="Type variant name. For example, Color" 
                                                                        className="variant-name-input"
                                                                        value={row.name}
                                                                        onChange={e => updVariantRow(row.id, 'name', e.target.value)}
                                                                        disabled={isCombinationCreated}
                                                                    />
                                                                    <input 
                                                                        placeholder="Type and select values" 
                                                                        className="variant-values-input"
                                                                        value={row.values}
                                                                        onChange={e => updVariantRow(row.id, 'values', e.target.value)}
                                                                        disabled={isCombinationCreated}
                                                                    />
                                                                    <button 
                                                                        className="delete-variant-btn" 
                                                                        onClick={() => removeVariantRow(row.id)}
                                                                        disabled={isCombinationCreated || variantRows.length === 1}
                                                                    >
                                                                        <Trash2 size={16} />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                                <div className="variant-actions-modern">
                                                    <button className="create-combination-btn" onClick={handleCreateCombination}>Create Combination</button>
                                                    <button className="add-variant-btn" onClick={addVariantRow} disabled={isCombinationCreated}>+ Add Variant</button>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Details Section */}
                                <div className="product-form-section-modern">
                                    <div className="section-header-modern">Details</div>
                                    <div className="section-content-modern">
                                        <div className="form-row-modern">
                                            <div className="form-group-modern">
                                                <label>Upload Image</label>
                                                <div className="drag-drop-area-modern">
                                                    <Image size={24} className="mb-8" />
                                                    <span>DRAG AND DROP A FILE OR SELECT ADD IMAGE</span>
                                                </div>
                                            </div>
                                            <div className="form-group-modern">
                                                <label>Thumbnail Image</label>
                                                <div className="drag-drop-area-modern">
                                                    <Image size={24} className="mb-8" />
                                                    <span>DRAG AND DROP A FILE OR SELECT ADD IMAGE</span>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="form-group-modern full-width">
                                            <label>Description</label>
                                            <textarea rows={3} placeholder="Enter Description" value={pf.description} onChange={e => upd('description', e.target.value)} />
                                        </div>

                                        <div className="form-row-modern align-center">
                                            <div className="form-group-modern">
                                                <label>Category <span className="required">*</span></label>
                                                <div className="input-with-action-modern">
                                                    <div className="input-with-icon-modern flex-grow">
                                                        <List size={16} className="input-icon" />
                                                        <select value={pf.categoryId} onChange={e => upd('categoryId', e.target.value)}>
                                                            <option value="">Select Category</option>
                                                            {(productOptions?.categories || []).map(c => <option key={c.Id} value={c.Id}>{c.CategoryName || c.Name}</option>)}
                                                        </select>
                                                    </div>
                                                    <button className="add-action-btn-modern">+ Add category</button>
                                                </div>
                                            </div>
                                            <label className="checkbox-label-modern ml-16" style={{ marginTop: 24 }}>
                                                <input type="checkbox" checked={pf.isActive} onChange={e => upd('isActive', e.target.checked)} />
                                                <span>Is Active</span>
                                            </label>
                                        </div>
                                    </div>
                                </div>

                                {/* Custom Section */}
                                <div className="product-form-section-modern">
                                    <div className="section-header-modern">Custom</div>
                                    <div className="section-content-modern">
                                        {/* Placeholder for custom fields */}
                                    </div>
                                </div>
                            </div>
                            <div className="product-add-footer modern-footer">
                                <button className="close-btn-modern" onClick={() => setIsProductAddOpen(false)}>Close</button>
                                <button className="save-apply-btn-modern" disabled={productSaving} onClick={handleSaveProduct}>
                                    {productSaving ? 'Saving...' : 'Save & Apply'}
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    };


    // ─── Render: Invoice Edit Panel ───────────────────────────────────────────
    const renderEditPanel = () => {
        if (!editView) return null;
        const d = editView;
        const leadDetail = d.leadDetail || {};
        const customerName = leadDetail.PersonName || d.ContactName || '-';
        const lineItems = d.quotationItems || [];
        const companyName = d.CompanyName || '-';
        const companyLogo = d.CompanyLogo || '';
        const logoInitial = companyName !== '-' ? companyName[0].toUpperCase() : 'U';
        const histories = d.quotationHistories || d.invoiceHistories || [];

        // Combine existing + added items into unified list
        const allItems = [
            ...lineItems.map((item, i) => ({ ...item, _key: `existing-${i}`, _type: 'existing', _idx: i })),
            ...addedItems.map((item, i) => ({ ...item, _key: `added-${i}`, _type: 'added', _idx: i })),
        ];

        let subTotal = 0;
        const allTaxSummary = {}; // { taxName: totalAmount }
        allItems.forEach(item => {
            const itemTotal = parseFloat(item.Total || 0);
            subTotal += itemTotal;
            const key = item._key;
            const disc = getDiscount(key);
            let itemDiscAmt = 0;
            if (disc.active && disc.value > 0) {
                itemDiscAmt = disc.type === 'percentage' ? (itemTotal * disc.value) / 100 : parseFloat(disc.value) || 0;
            }
            const itemAfterDisc = itemTotal - itemDiscAmt;

            // Existing taxes
            (item.quotationItemTaxes || []).forEach(t => {
                const rate = parseFloat(t.Rate || 0);
                const amt = disc.active && rate > 0 ? (itemAfterDisc * rate) / 100 : parseFloat(t.Amount || 0);
                allTaxSummary[t.Name] = (allTaxSummary[t.Name] || 0) + amt;
            });

            // Added taxes
            (itemAddedTaxes[key] || []).forEach(at => {
                const amt = at.Type === 'fixed' ? at.Rate : (itemAfterDisc * at.Rate) / 100;
                allTaxSummary[at.Name] = (allTaxSummary[at.Name] || 0) + amt;
            });
        });

        const totalDiscount = allItems.reduce((s, item) => {
            const disc = getDiscount(item._key);
            if (!disc.active || disc.value <= 0) return s;
            return s + (disc.type === 'percentage' ? (parseFloat(item.Total || 0) * disc.value) / 100 : parseFloat(disc.value) || 0);
        }, 0);

        const taxTotal = Object.values(allTaxSummary).reduce((s, v) => s + v, 0);
        const chargesTotal = addedCharges.reduce((s, c) => s + (parseFloat(c.amount) || 0), 0);
        const grandTotal = subTotal - totalDiscount + taxTotal + chargesTotal;
        let currencySymbol = selectedCurrency?.Symbol || editView?.CurrencySymbol || '$';
        if (currencySymbol === 'Rp') currencySymbol = '₹';
        const stripHtml = (html) => (html || '').replace(/<[^>]+>/g, '').replace(/&nbsp;/g, ' ').trim();

        const safeStrLocal = (val, fallback = '-') => {
            if (!val) return fallback;
            if (typeof val === 'string') return val || fallback;
            if (typeof val === 'object') return val.Text || val.Code || val.Name || val.Value || String(val.Id || '') || fallback;
            return String(val) || fallback;
        };

        return (
            <div className="quotation-edit-overlay quotation-edit-overlay-layer" onClick={() => setEditView(null)}>
                <div className="quotation-edit-panel" onClick={(e) => e.stopPropagation()}>

                    {/* Back Bar */}
                    <div className="edit-nav-row">
                        <div className="edit-back-bar-left" onClick={() => setEditView(null)}>
                            <X size={18} />
                            <span>Back to Quotation</span>
                        </div>
                    </div>
                    <div className="edit-back-bar">
                        <div className="edit-inline-title">New Quotation</div>
                    </div>

                    {editLoading ? (
                        <div style={{ padding: '40px' }}><Loader message="Loading quotation..." /></div>
                    ) : (
                        <div className="edit-content" style={{ position: 'relative' }}>
                            {saveLoading && (
                                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(255,255,255,0.7)', zIndex: 10, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Loader message="Saving quotation..." />
                                </div>
                            )}

                            {/* ── Company Collapsible Row ── */}
                            <div className={`edit-company-bar ${companyOpen ? 'open' : ''}`}
                                onClick={() => setCompanyOpen(!companyOpen)}>
                                <div className="edit-company-initial">
                                    {companyOpen ? <ChevronDown size={20} /> : <ChevronRight size={18} />}
                                </div>
                                <span className="edit-company-label">Company</span>
                            </div>

                            {/* ── Expanded Company Section ── */}
                            {companyOpen && (
                                <div className="edit-company-section">
                                    <div className="edit-logo-row">
                                        <div className="edit-logo-avatar">
                                            {companyLogo
                                                ? <img src={companyLogo} alt="logo" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
                                                : <span>{logoInitial}</span>}
                                        </div>
                                        <button className="edit-logo-remove">remove</button>
                                    </div>

                                    <div className="edit-form-grid-2">
                                        <div className="edit-form-group">
                                            <label>Title</label>
                                            <input type="text" placeholder="Invoice" value={editForm.title || ''} onChange={(e) => setEditForm({ ...editForm, title: e.target.value })} />
                                        </div>
                                        <div className="edit-form-group">
                                            <label>Subheading</label>
                                            <input type="text" placeholder="This is your Invoice" value={editForm.subheading || ''} onChange={(e) => setEditForm({ ...editForm, subheading: e.target.value })} />
                                        </div>
                                    </div>


                                    <div className="edit-company-info">
                                        <div className="edit-company-name" style={{ fontWeight: 700, fontSize: '15px', color: '#1e293b', marginBottom: '4px' }}>{safeStrLocal(companyName)}</div>
                                        <div className="edit-company-detail">✉ {safeStrLocal(d.CompanyEmail || d.Email)}</div>
                                        <div className="edit-company-detail">☎ {safeStrLocal(d.CompanyPhone || d.Mobile || d.PhoneNumber)}</div>
                                        <div className="edit-company-detail">📍 {safeStrLocal(d.CompanyAddress || d.Address)}</div>
                                        {(d.CompanyTaxNumber || d.GSTNumber) && (
                                            <div className="edit-company-detail" style={{ fontWeight: 500 }}>
                                                % Tax Number: {safeStrLocal(d.CompanyTaxNumber || d.GSTNumber)}
                                            </div>
                                        )}
                                        {(d.CompanyPanNumber || d.PanNumber) && (
                                            <div className="edit-company-detail" style={{ fontWeight: 500 }}>
                                                % Pan Number: {safeStrLocal(d.CompanyPanNumber || d.PanNumber)}
                                            </div>
                                        )}
                                        <a href="#0" className="edit-company-edit-link">Edit your business address</a>
                                    </div>

                                    <div className="edit-form-group" style={{ marginTop: 16 }}>
                                        <label>Sales Owner</label>
                                        <select value={editForm.salesOwner || ''} onChange={(e) => setEditForm({ ...editForm, salesOwner: e.target.value })} className="edit-select">
                                            <option value="">Nothing selected</option>
                                            {ownerOptions.map((o, i) => (
                                                <option key={i} value={o.Code || o.UserId || o.Id || ''}>
                                                    {o.Text || o.Name || o.FullName || String(i)}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            )}

                            {/* ── Main Edit Form (visible when company closed) ── */}
                            {!companyOpen && (
                                <div className="edit-main-form">
                                    <div className="edit-top-grid">
                                        {/* Bill To */}
                                        <div className="edit-bill-box">
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                                <span style={{ fontWeight: 600, fontSize: 13, color: '#1e293b' }}>Bill To</span>
                                                {(!editView?._isAdd || ((billToForm.name || d.BillToName || customerName) && (billToForm.name || d.BillToName || customerName) !== '-')) && (
                                                    <button onClick={() => openBillToModal(d)} title="Edit lead address" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#3b82f6', padding: '2px 4px', display: 'flex', alignItems: 'center' }}><Edit3 size={14} /></button>
                                                )}
                                            </div>

                                            {/* Customer search input */}
                                            {customerSearchOpen && (
                                                <div className="customer-search-container">
                                                    <input
                                                        type="text"
                                                        className="customer-search-input"
                                                        placeholder="Type a Customer name"
                                                        value={customerSearchText}
                                                        onChange={(e) => {
                                                            setCustomerSearchText(e.target.value);
                                                            fetchCustomerSuggestions(e.target.value);
                                                        }}
                                                        autoFocus
                                                    />
                                                    {customerSuggestions.length > 0 && (
                                                        <div className="customer-suggestions-dropdown">
                                                            {customerSuggestions.map((cust, ci) => {
                                                                const name = cust.PersonName || cust.Name || '-';
                                                                const profileImg = cust.ProfileImgFileName || cust.ProfileImage || cust.Image || '';
                                                                const isDefaultAvatar = !profileImg || profileImg.includes('img_avatar1.png') || profileImg.includes('avatar');
                                                                
                                                                const getInitials = (str) => {
                                                                    if (!str) return 'U';
                                                                    const cleanStr = str.replace(/^[^a-zA-Z0-9]+/, '');
                                                                    if (!cleanStr) return 'U';
                                                                    if (/^\d/.test(cleanStr)) return cleanStr.substring(0, 2);
                                                                    const words = cleanStr.trim().split(/\s+/);
                                                                    if (words.length >= 2) return (words[0][0] + (words[1][0] || '')).toUpperCase();
                                                                    return words[0][0].toUpperCase();
                                                                };

                                                                const getAvatarColors = (str) => {
                                                                    const pairs = [
                                                                        { bg: '#fef9c3', text: '#a16207' }, // Yellow
                                                                        { bg: '#dbeafe', text: '#1e40af' }, // Blue
                                                                        { bg: '#dcfce7', text: '#166534' }, // Green
                                                                        { bg: '#f3e8ff', text: '#6b21a8' }, // Purple
                                                                        { bg: '#fce7f3', text: '#9d174d' }, // Pink
                                                                        { bg: '#ffedd5', text: '#9a3412' }, // Orange
                                                                        { bg: '#e0f2fe', text: '#0369a1' }, // Sky
                                                                    ];
                                                                    const index = (str || '').split('').reduce((acc, char) => acc + char.charCodeAt(0), 0) % pairs.length;
                                                                    return pairs[index];
                                                                };
                                                                const avatarColor = getAvatarColors(name);

                                                                return (
                                                                    <div key={cust.LeadId || cust.Id || ci} className="customer-suggestion-item" onClick={() => handleSelectCustomer(cust)}>
                                                                        <div className="customer-suggestion-avatar" style={{ borderRadius: '50%', overflow: 'hidden', backgroundColor: avatarColor.bg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                                            {!isDefaultAvatar
                                                                                ? <img src={profileImg} alt="" className="customer-avatar-img" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                                                                                : <span className="customer-avatar-initial" style={{ fontSize: 13, fontWeight: 700, color: avatarColor.text }}>{getInitials(name)}</span>
                                                                            }
                                                                        </div>
                                                                        <div className="customer-suggestion-info">
                                                                            <div className="customer-suggestion-name-row">
                                                                                <span className="customer-suggestion-name">{name}</span>
                                                                                {(cust.MobileNo || cust.Mobile || cust.Phone) && (
                                                                                    <span className="customer-suggestion-pill mobile">
                                                                                        {cust.MobileNo || cust.Mobile || cust.Phone}
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                            <div className="customer-suggestion-meta">
                                                                                {(cust.CompanyName) && (
                                                                                    <span className="customer-suggestion-detail company">
                                                                                        <Box component="span" sx={{ opacity: 0.7, mr: 0.5 }}>🏢</Box> {cust.CompanyName}
                                                                                    </span>
                                                                                )}
                                                                                {(cust.EmailID || cust.Email || cust.EmailId) && (
                                                                                    <span className="customer-suggestion-detail email">
                                                                                        <Box component="span" sx={{ opacity: 0.7, mr: 0.5 }}>✉</Box> {cust.EmailID || cust.Email || cust.EmailId}
                                                                                    </span>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            )}

                                            {/* Show customer details or Add a Customer */}
                                            {!customerSearchOpen && (
                                                (billToForm.name || d.BillToName || customerName) && (billToForm.name || d.BillToName || customerName) !== '-' ? (
                                                    <>
                                                        <div className="edit-bill-name" style={{ fontWeight: 600, color: '#1e293b' }}>
                                                            {billToForm.company || d.CompanyName || billToForm.name || d.BillToName || customerName}
                                                        </div>
                                                        {(billToForm.company || d.CompanyName) && (billToForm.name || d.BillToName) && (
                                                            <div className="edit-bill-line" style={{ color: '#64748b' }}>{billToForm.name || d.BillToName}</div>
                                                        )}
                                                        {(billToForm.taxNumber || d.ContactTaxNumber?.trim()) && <div className="edit-bill-line" style={{ color: '#64748b' }}>Tax Number: {billToForm.taxNumber || d.ContactTaxNumber}</div>}
                                                        {(billToForm.panNumber || d.ContactPanNumber?.trim()) && <div className="edit-bill-line" style={{ color: '#64748b' }}>Pan Number: {billToForm.panNumber || d.ContactPanNumber}</div>}
                                                        {(billToForm.email || d.ContactEmail) && <div className="edit-bill-line" style={{ color: '#64748b' }}>{billToForm.email || d.ContactEmail}</div>}
                                                        <div className="edit-bill-line" style={{ color: '#64748b' }}>
                                                            {billToForm.address || d.ContactAddress || '.'}, {billToForm.cityName || d.BillToCity || ''}, {billToForm.stateName || d.BillToState || ''}, {billToForm.countryName || d.BillToCountry || ''}, {billToForm.pincode || d.BillToPincode || ''}
                                                        </div>
                                                        <a href="#0" className="edit-choose-link" onClick={(e) => { e.preventDefault(); setCustomerSearchOpen(true); setCustomerSearchText(''); setCustomerSuggestions([]); }}>Choose a different customer</a>
                                                    </>
                                                ) : (
                                                    <div className="add-customer-card" onClick={() => { setCustomerSearchOpen(true); setCustomerSearchText(''); setCustomerSuggestions([]); }}>
                                                        <div className="add-customer-icon">👤</div>
                                                        <span className="add-customer-text">Add a Customer</span>
                                                    </div>
                                                )
                                            )}
                                        </div>

                                        {/* Ship To */}
                                        <div className="edit-bill-box">
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                                                    <span style={{ fontWeight: 600, fontSize: 13, color: '#1e293b' }}>Ship To</span>
                                                    <label style={{ fontSize: 11, color: '#64748b', fontWeight: 400, display: 'inline-flex', alignItems: 'center', gap: 4, cursor: 'pointer' }}>
                                                        <input type="checkbox" checked={isSameAsBillTo} onChange={(e) => setIsSameAsBillTo(e.target.checked)} style={{ width: 13, height: 13 }} />
                                                        Same as Bill To
                                                    </label>
                                                </div>
                                                {(!editView?._isAdd || (isSameAsBillTo 
                                                    ? ((billToForm.name || d.BillToName || customerName) && (billToForm.name || d.BillToName || customerName) !== '-') 
                                                    : ((shipToForm.name || d.ShipToName || customerName) && (shipToForm.name || d.ShipToName || customerName) !== '-'))) && (
                                                    <button onClick={() => openShipToModal(d)} title="Edit shipping address" style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#3b82f6', padding: '2px 4px', display: 'flex', alignItems: 'center' }}><Edit3 size={14} /></button>
                                                )}
                                            </div>
                                            {(isSameAsBillTo 
                                                ? (billToForm.name || d.BillToName || customerName) 
                                                : (shipToForm.name || d.ShipToName || customerName)) && (isSameAsBillTo 
                                                ? (billToForm.name || d.BillToName || customerName) 
                                                : (shipToForm.name || d.ShipToName || customerName)) !== '-' && (
                                                <>
                                                    <div className="edit-bill-name" style={{ fontWeight: 600, color: '#1e293b' }}>
                                                        {isSameAsBillTo 
                                                            ? (billToForm.company || d.CompanyName || billToForm.name || d.BillToName || customerName) 
                                                            : (shipToForm.company || d.ShipToCompanyName || d.CompanyName || shipToForm.name || d.ShipToName || customerName)}
                                                    </div>
                                                    {isSameAsBillTo ? (
                                                        (billToForm.company || d.CompanyName) && (billToForm.name || d.BillToName) && (
                                                            <div className="edit-bill-line" style={{ color: '#64748b' }}>{billToForm.name || d.BillToName}</div>
                                                        )
                                                    ) : (
                                                        (shipToForm.company || d.ShipToCompanyName || d.CompanyName) && (shipToForm.name || d.ShipToName) && (
                                                            <div className="edit-bill-line" style={{ color: '#64748b' }}>{shipToForm.name || d.ShipToName}</div>
                                                        )
                                                    )}
                                                    {(isSameAsBillTo ? (billToForm.email || d.ContactEmail) : (shipToForm.email || d.ShipToEmailId)) && (
                                                        <div className="edit-bill-line" style={{ color: '#64748b' }}>{isSameAsBillTo ? (billToForm.email || d.ContactEmail) : (shipToForm.email || d.ShipToEmailId)}</div>
                                                    )}
                                                    <div className="edit-bill-line" style={{ color: '#64748b' }}>
                                                        {isSameAsBillTo ? (
                                                            <>{[billToForm.address || d.ContactAddress, billToForm.cityName || d.BillToCity, billToForm.stateName || d.BillToState, billToForm.countryName || d.BillToCountry, billToForm.pincode || d.BillToPincode].filter(p => p && p !== '.').join(', ') || ''}</>
                                                        ) : (
                                                            <>{[shipToForm.address || d.ShipToAddress, shipToForm.cityName || d.ShipToCity, shipToForm.stateName || d.ShipToState, shipToForm.countryName || d.ShipToCountry, shipToForm.pincode || d.ShipToPincode].filter(p => p && p !== '.').join(', ') || ''}</>
                                                        )}
                                                    </div>
                                                </>
                                            )}
                                        </div>

                                        {/* Quotation Number + Dates */}
                                        <div className="edit-invoice-meta">
                                            <div className="edit-form-group">
                                                <label>Quotation Number</label>
                                                <input
                                                    type="text"
                                                    value={editForm.quotationNumber || ''}
                                                    onChange={(e) => setEditForm({ ...editForm, quotationNumber: e.target.value })}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f1f5f9', cursor: 'not-allowed', color: '#64748b' }}
                                                />
                                            </div>
                                            <div className="edit-form-grid-2" style={{ marginTop: 12 }}>
                                                <div className="edit-form-group">
                                                    <label>Quotation Date</label>
                                                    <div style={{ position: 'relative' }}>
                                                        <input
                                                            type="text"
                                                            readOnly
                                                            value={editForm.quotationDate || ''}
                                                            placeholder="DD-Mon-YYYY"
                                                            style={{ cursor: 'pointer', width: '100%' }}
                                                            onClick={() => { if (quotationDateRef.current) { try { quotationDateRef.current.showPicker(); } catch(e) { quotationDateRef.current.click(); } } }}
                                                        />
                                                        <input
                                                            ref={quotationDateRef}
                                                            type="date"
                                                            value={toDateInputValue(editForm.quotationDate)}
                                                            min={toDateInputValue(new Date())}
                                                            onChange={(e) => setEditForm({ ...editForm, quotationDate: e.target.value ? formatDate(e.target.value) : '' })}
                                                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer', border: 'none', pointerEvents: 'none' }}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="edit-form-group">
                                                    <label>Payment Due Date</label>
                                                    <div style={{ position: 'relative' }}>
                                                        <input
                                                            type="text"
                                                            readOnly
                                                            value={editForm.dueDate || ''}
                                                            placeholder="DD-Mon-YYYY"
                                                            style={{ cursor: 'pointer', width: '100%' }}
                                                            onClick={() => { if (dueDateRef.current) { try { dueDateRef.current.showPicker(); } catch(e) { dueDateRef.current.click(); } } }}
                                                        />
                                                        <input
                                                            ref={dueDateRef}
                                                            type="date"
                                                            value={toDateInputValue(editForm.dueDate)}
                                                            min={toDateInputValue(editForm.quotationDate) || toDateInputValue(new Date())}
                                                            onChange={(e) => setEditForm({ ...editForm, dueDate: e.target.value ? formatDate(e.target.value) : '' })}
                                                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer', border: 'none', pointerEvents: 'none' }}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Place of Supply / Origin / Currency */}
                                    <div className="edit-supply-row">
                                        <div className="edit-supply-item">
                                            <label>Place of Supply :</label>
                                            <input type="text" value={editForm.placeOfSupply || ''} onChange={(e) => setEditForm({ ...editForm, placeOfSupply: e.target.value })} />
                                        </div>
                                        <div className="edit-supply-item">
                                            <label>Place of Origin :</label>
                                            <div className="edit-input-group">
                                                <input type="text" value={editForm.placeOfOrigin || ''} onChange={(e) => setEditForm({ ...editForm, placeOfOrigin: e.target.value })} />
                                                <button className="edit-input-btn"><Edit3 size={14} /></button>
                                            </div>
                                        </div>
                                        <div className="edit-supply-item">
                                            <label>Currency</label>
                                            <div className="edit-currency-wrap">
                                                <div className="edit-currency-icon"><Banknote size={16} /></div>
                                                <select
                                                    className="edit-currency-select"
                                                    value={selectedCurrency?.Id || d.CurrencyId || ''}
                                                    onChange={(e) => {
                                                        const curr = currencyList.find(c => String(c.Id) === e.target.value);
                                                        if (curr) setSelectedCurrency(curr);
                                                    }}
                                                >
                                                    {currencyList.length === 0 && (
                                                        <option value={d.CurrencyId || ''}>{d.CurrencyName || 'Dollars'} ({d.CurrencySymbol === 'Rp' ? '₹' : (d.CurrencySymbol || '$')})</option>
                                                    )}
                                                    {currencyList.map(c => (
                                                        <option key={c.Id} value={c.Id}>{c.Name} ({c.Symbol})</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Items Table */}
                                    <div className="edit-items-section">
                                        <table className="edit-items-table">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: 28 }}></th>
                                                    <th>Model</th>
                                                    <th>Preview</th>
                                                    <th>Quantity</th>
                                                    <th>Price</th>
                                                    <th>Amount</th>
                                                    <th>HSN/SAC Code</th>
                                                    <th>Taxes</th>
                                                    <th>TaxAmount</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {allItems.length > 0 ? allItems.map((item) => {
                                                    const itemKey = item._key;
                                                    const itemTaxes = item.quotationItemTaxes || [];
                                                    const disc = getDiscount(itemKey);
                                                    const itemTotal = parseFloat(item.Total || 0);
                                                    let itemDiscAmt = 0;
                                                    if (disc.active && disc.value > 0) {
                                                        itemDiscAmt = disc.type === 'percentage' ? (itemTotal * disc.value) / 100 : parseFloat(disc.value) || 0;
                                                    }
                                                    const itemAfterDisc = itemTotal - itemDiscAmt;
                                                    const perItemAddedTaxes = itemAddedTaxes[itemKey] || [];
                                                    const isTaxSearchOpen = itemTaxSearchOpen[itemKey] || false;

                                                    let hsnDisplay = item.ItemHsnSacCode || '';
                                                    if (!hsnDisplay && item.ProductJSON) {
                                                        try {
                                                            const pData = JSON.parse(item.ProductJSON);
                                                            const code = pData.HSNCode || pData.SACCode;
                                                            if (code) hsnDisplay = `${pData.HSNCode ? 'HSN' : 'SAC'}: ${code}`;
                                                        } catch (e) { }
                                                    } else if (hsnDisplay) {
                                                        hsnDisplay = `HSN: ${hsnDisplay}`;
                                                    }
                                                    if (!hsnDisplay) hsnDisplay = '-';

                                                    return (
                                                        <React.Fragment key={itemKey}>
                                                            <tr className="edit-item-row">
                                                                <td><span className="drag-handle"><GripVertical size={14} /></span></td>
                                                                <td>
                                                                    <div className="edit-item-cell">
                                                                        <span>{item.Name || '-'}</span>
                                                                        <button className="edit-item-pencil" onClick={() => setItemEntityModal({ open: true, index: item._idx, value: item.Name || '' })}><Edit3 size={12} /></button>
                                                                    </div>
                                                                </td>
                                                                <td>
                                                                    <div className="edit-item-cell">
                                                                        <span className="text-truncate edit-description-html" style={{ maxWidth: '150px' }} dangerouslySetInnerHTML={{ __html: item.Description || '-' }}></span>
                                                                        <button className="edit-item-pencil" onClick={() => {
                                                                            setItemDescModal({ open: true, index: item._idx, value: item.Description || '', type: item._type });
                                                                            fetchPreviewSuggestions();
                                                                        }}><Edit3 size={12} /></button>
                                                                    </div>
                                                                </td>
                                                                <td>{item.Quantity || 1}</td>
                                                                <td>{currencySymbol} {parseFloat(item.Price || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                                                <td>{currencySymbol} {itemTotal.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                                                <td style={{ fontSize: '11px', color: '#64748b' }}>{hsnDisplay}</td>
                                                                <td>{item.ItemTax || '-'}</td>
                                                                <td>{item.ItemTaxAmount || '-'}</td>
                                                                <td>
                                                                    <button className="edit-item-delete" onClick={() => {
                                                                        if (item._type === 'added') handleDeleteAddedItem(item._idx);
                                                                        else handleDeleteItem(item._idx);
                                                                    }}><Trash2 size={14} /></button>
                                                                </td>
                                                            </tr>

                                                            {/* Discount row for this item */}
                                                            {disc.active && (
                                                                <tr className="tax-subrow discount-subrow">
                                                                    <td></td>
                                                                    <td colSpan="2" style={{ fontWeight: 600, color: '#475569' }}>Discount</td>
                                                                    <td colSpan="2">
                                                                        <div className="discount-toggle-wrap">
                                                                            <label className={`discount-radio-label ${disc.type === 'percentage' ? 'active' : ''}`}>
                                                                                <input type="radio" name={`discType-${itemKey}`} checked={disc.type === 'percentage'} onChange={() => setDiscountForItem(itemKey, prev => ({ ...prev, type: 'percentage' }))} />
                                                                                <span className="discount-radio-icon">%</span>
                                                                            </label>
                                                                            <label className={`discount-radio-label ${disc.type === 'fixed' ? 'active' : ''}`}>
                                                                                <input type="radio" name={`discType-${itemKey}`} checked={disc.type === 'fixed'} onChange={() => setDiscountForItem(itemKey, prev => ({ ...prev, type: 'fixed' }))} />
                                                                                <span className="discount-radio-icon">{currencySymbol}</span>
                                                                            </label>
                                                                            <input
                                                                                type="number"
                                                                                className="discount-value-input"
                                                                                value={disc.value || ''}
                                                                                onChange={(e) => setDiscountForItem(itemKey, prev => ({ ...prev, value: parseFloat(e.target.value) || 0 }))}
                                                                                placeholder="0"
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    <td style={{ color: '#64748b' }}>%</td>
                                                                    <td colSpan="2" style={{ fontWeight: 600, color: '#1e293b' }}>
                                                                        {currencySymbol}{itemDiscAmt.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                                                    </td>
                                                                    <td></td>
                                                                    <td>
                                                                        <button className="edit-item-delete" onClick={() => setDiscountForItem(itemKey, { active: false, type: 'percentage', value: 0 })}>
                                                                            <Trash2 size={14} />
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            )}

                                                            {/* Existing taxes for this item */}
                                                            {itemTaxes.map((t, ti) => {
                                                                const rate = parseFloat(t.Rate || 0);
                                                                const taxAmt = disc.active && rate > 0 ? (itemAfterDisc * rate) / 100 : parseFloat(t.Amount || 0);
                                                                return (
                                                                    <tr key={`etax-${itemKey}-${ti}`} className="tax-subrow">
                                                                        <td></td><td colSpan="2"></td><td></td><td></td><td></td>
                                                                        <td style={{ color: '#64748b' }}>{t.Name}</td>
                                                                        <td><input defaultValue={t.Rate} readOnly style={{ width: 48, border: '1px solid #e2e8f0', borderRadius: 4, padding: '2px 6px', backgroundColor: '#f8fafc', cursor: 'not-allowed' }} /></td>
                                                                        <td>%</td>
                                                                        <td>{currencySymbol} {taxAmt.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                                                        <td><span style={{ color: '#ef4444', cursor: 'pointer' }}>🗑</span></td>
                                                                    </tr>
                                                                );
                                                            })}

                                                            {/* Added taxes for this item */}
                                                            {perItemAddedTaxes.map((at, ati) => {
                                                                const taxAmt = at.Type === 'fixed' ? at.Rate : (itemAfterDisc * at.Rate) / 100;
                                                                return (
                                                                    <tr key={`addtax-${itemKey}-${ati}`} className="tax-subrow">
                                                                        <td></td><td colSpan="2"></td><td></td><td></td><td></td>
                                                                        <td style={{ color: '#64748b' }}>{at.Name}</td>
                                                                        <td><input value={at.Rate} readOnly style={{ width: 48, border: '1px solid #e2e8f0', borderRadius: 4, padding: '2px 6px', backgroundColor: '#f8fafc', cursor: 'not-allowed' }} /></td>
                                                                        <td>%</td>
                                                                        <td>{currencySymbol} {taxAmt.toLocaleString('en-US', { minimumFractionDigits: 2 })}</td>
                                                                        <td><button className="edit-item-delete" onClick={() => handleDeleteAddedTax(itemKey, ati)}><Trash2 size={14} /></button></td>
                                                                    </tr>
                                                                );
                                                            })}

                                                            {/* Per-item tax search dropdown (inline) */}
                                                            {isTaxSearchOpen && (
                                                                <tr className="tax-subrow">
                                                                    <td></td>
                                                                    <td colSpan="9">
                                                                        <div className="tax-search-container" style={{ padding: '4px 0' }}>
                                                                            <input
                                                                                type="text"
                                                                                className="tax-search-input"
                                                                                placeholder="Type a tax name"
                                                                                value={taxSearchText}
                                                                                onChange={(e) => {
                                                                                    setTaxSearchText(e.target.value);
                                                                                    fetchTaxSuggestions(e.target.value);
                                                                                }}
                                                                                autoFocus
                                                                            />
                                                                            {taxSuggestions.length > 0 && (
                                                                                <div className="tax-suggestions-dropdown">
                                                                                    {taxSuggestions.map((tax) => (
                                                                                        <div key={tax.Id} className="tax-suggestion-item" onClick={() => handleSelectTax(tax, itemKey)}>
                                                                                            <div className="tax-suggestion-name">{tax.Name}</div>
                                                                                            <div className="tax-suggestion-rate">{tax.Rate}</div>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            )}

                                                            {/* Per-item action buttons */}
                                                            <tr className="tax-subrow">
                                                                <td></td>
                                                                <td colSpan="9" style={{ textAlign: 'right', paddingRight: 16 }}>
                                                                    <button className="edit-add-btn" onClick={() => {
                                                                        if (disc.active) {
                                                                            Swal.fire({ title: 'Already Added', text: 'Discount has already been added. Please remove the existing discount first.', icon: 'warning', confirmButtonText: 'OK', confirmButtonColor: '#f59e0b' });
                                                                        } else {
                                                                            setDiscountForItem(itemKey, { active: true, type: 'percentage', value: 0 });
                                                                        }
                                                                    }}>+ Add Discount</button>
                                                                    <button className="edit-add-btn" style={{ marginLeft: 16 }} onClick={() => {
                                                                        setItemTaxSearchOpen(prev => ({ ...prev, [itemKey]: !prev[itemKey] }));
                                                                        setTaxSearchText('');
                                                                        setTaxSuggestions([]);
                                                                    }}>+ Add Tax</button>
                                                                </td>
                                                            </tr>
                                                        </React.Fragment>
                                                    );
                                                }) : (
                                                    <tr><td colSpan="10" style={{ textAlign: 'center', color: '#94a3b8', padding: 20 }}>No items</td></tr>
                                                )}
                                            </tbody>
                                        </table>

                                        {/* Add Item Row */}
                                        <div className="edit-add-row">
                                            <button className="edit-add-btn" onClick={() => setItemSearchOpen(prev => !prev)}>+ Add an Item</button>
                                        </div>

                                        {/* Item Search Dropdown */}
                                        {itemSearchOpen && (
                                            <div className="tax-search-container">
                                                <input
                                                    type="text"
                                                    className="tax-search-input"
                                                    placeholder="Type an item name"
                                                    value={itemSearchText}
                                                    onChange={(e) => {
                                                        setItemSearchText(e.target.value);
                                                        fetchItemSuggestions(e.target.value);
                                                    }}
                                                    autoFocus
                                                />
                                                {(itemSuggestions.length > 0 || itemSearchText.length > 0) && (
                                                    <div className="tax-suggestions-dropdown">
                                                        {itemSuggestions.map((prod) => (
                                                            <div key={prod.Id} className="tax-suggestion-item item-suggestion-item" onClick={() => handleSelectItem(prod)}>
                                                                <div className="item-suggestion-left">
                                                                    <div className="item-suggestion-img">📦</div>
                                                                    <div>
                                                                        <div className="tax-suggestion-name">{prod.Name} &nbsp; <span style={{ color: '#64748b', fontWeight: 400 }}>☰ {prod.SalePrice || prod.Price || 0}</span></div>
                                                                        <div className="tax-suggestion-rate">{prod.Description || prod.Remarks || ''}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                        <div className="product-dropdown-footer">
                                                            <button className="edit-add-btn" style={{ width: '100%', border: 'none', background: 'none', color: '#1e293b', fontWeight: 700, fontSize: '14px', padding: '12px', cursor: 'pointer' }} onClick={() => { resetProductForm(); setIsProductAddOpen(true); fetchProductFormOptions(); }}>+Add New</button>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        )}

                                        {/* Totals */}
                                        <div className="edit-totals" style={{ marginTop: 0 }}>
                                            <div className="totals-row">
                                                <span>SUB TOTAL</span>
                                                <span>{currencySymbol} &nbsp; {subTotal.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
                                            </div>
                                            {Object.entries(allTaxSummary).map(([name, amount], i) => (
                                                <div className="totals-row" key={`tax-${i}`}>
                                                    <span>{name.toUpperCase().replace(/_/g, ' ')}</span>
                                                    <span>{currencySymbol} &nbsp; {amount.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
                                                </div>
                                            ))}
                                            {addedCharges.map((ch, ci) => (
                                                <div className="totals-row" key={`charge-${ci}`}>
                                                    <span>{ch.type.toUpperCase()}</span>
                                                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                                        {currencySymbol} &nbsp; {parseFloat(ch.amount).toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                                        <button className="charge-delete-btn" onClick={() => setAddedCharges(prev => prev.filter((_, i) => i !== ci))}>■</button>
                                                    </span>
                                                </div>
                                            ))}
                                            <div className="grand-total-premium">
                                                <span>GRAND TOTAL</span>
                                                <span>{currencySymbol} {grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
                                            </div>
                                            <div style={{ textAlign: 'right', marginTop: 4 }}>
                                                <button className="edit-add-btn" style={{ fontSize: 12 }} onClick={() => setChargeModal({ open: true, type: '', amount: '' })}>+Add Charges</button>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Terms & Condition */}
                                    <div className="edit-rich-section">
                                        <div className="edit-rich-label">Terms &amp; Condition</div>
                                        <div className="quill-editor-wrap">
                                            <SafeQuill
                                                theme="snow"
                                                value={editForm.termsCondition || ''}
                                                onChange={handleTermsChange}
                                                modules={quillModules}
                                                placeholder="Enter terms & conditions..."
                                            />
                                        </div>
                                    </div>

                                    {/* Notes */}
                                    <div className="edit-rich-section">
                                        <div className="edit-rich-label">Notes</div>
                                        <div className="quill-editor-wrap">
                                            <SafeQuill
                                                theme="snow"
                                                value={editForm.notes || ''}
                                                onChange={handleNotesChange}
                                                modules={quillModules}
                                                placeholder="Enter notes..."
                                            />
                                        </div>
                                    </div>

                                    {/* Footer (collapsible) */}
                                    <div className="edit-rich-section">
                                        <div className="edit-rich-label footer-toggle" onClick={() => setFooterOpen(prev => !prev)}>
                                            <span>Footer</span>
                                            {footerOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                                        </div>
                                        {footerOpen && (
                                            <>
                                                <div className="edit-rich-label" style={{ fontSize: 12, marginTop: 8 }}>Footer Content</div>
                                                <div className="quill-editor-wrap">
                                                    <SafeQuill
                                                        theme="snow"
                                                        value={editForm.footer || ''}
                                                        onChange={handleFooterChange}
                                                        modules={quillModules}
                                                        placeholder="Enter footer content..."
                                                    />
                                                </div>
                                            </>
                                        )}
                                    </div>

                                    {/* Activity History in Edit (New) */}
                                    <div className="edit-rich-section">
                                        <div className="edit-rich-label footer-toggle" onClick={() => setShowHistory(prev => !prev)} style={{ background: '#f8fafc' }}>
                                            <span>Activity History</span>
                                            {showHistory ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                                        </div>
                                        {showHistory && (
                                            <div style={{ marginTop: 12, overflowX: 'auto' }}>
                                                <table className="detail-history-table" style={{ border: '1px solid #e2e8f0' }}>
                                                    <thead>
                                                        <tr>
                                                            <th>Date</th>
                                                            <th>Action</th>
                                                            <th>By</th>
                                                            <th>Remark</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {histories.length > 0 ? histories.map((h, i) => (
                                                            <tr key={i}>
                                                                <td><span style={{ fontWeight: 600 }}>{h.CreatedOn || h.Date || '-'}</span></td>
                                                                <td>
                                                                    <span className={`status-badge ${String(h.Status || '').toLowerCase().replace(/\s+/g, '-')}`}>
                                                                        {h.Status || h.Action || '-'}
                                                                    </span>
                                                                </td>
                                                                <td>{h.CreatedBy || h.By || '-'}</td>
                                                                <td dangerouslySetInnerHTML={{ __html: h.Discription || h.Description || h.Remark || '-' }}></td>
                                                            </tr>
                                                        )) : (
                                                            <tr>
                                                                <td colSpan="4" style={{ textAlign: 'center', color: '#94a3b8', padding: '16px' }}>No activity logged</td>
                                                            </tr>
                                                        )}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>

                                    {/* Action Buttons */}
                                    <div className="edit-action-bar">
                                        <button className="edit-cancel-btn" onClick={() => setEditView(null)}>Cancel</button>
                                        <button className="edit-save-btn" onClick={handleSave} disabled={saveLoading}>
                                            {saveLoading ? 'Saving...' : 'Save'}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const handlePrint = async (customQuotation = null) => {
        const qSource = customQuotation || showView;
        const quoteId =
            qSource?._targetEntityId ||
            qSource?.QuoteId ||
            qSource?.QuotationId ||
            qSource?.ID ||
            qSource?.Id ||
            qSource?.Details?.Id ||
            qSource?._quotation?.QuoteId ||
            qSource?._quotation?.QuotationId ||
            qSource?._quotation?.ID ||
            qSource?._quotation?.Id;

        if (!quoteId) {
            Swal.fire({
                title: 'Error',
                text: 'Quotation ID not found.',
                icon: 'error',
                confirmButtonColor: '#ef4444'
            });
            return;
        }

        try {
            const payload = {
                Token: "-2295521862261168",
                Details: {
                    QuotationId: Number(quoteId) || 0,
                    InvoiceId: 0
                }
            };

            const response = await fetch(Get_Quotation_Link, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                if (result && result.Status === 1 && result.Details) {
                    const printWindow = window.open(result.Details, '_blank');
                    if (printWindow) {
                        printWindow.focus();
                    }
                } else {
                    Swal.fire({
                        title: 'Service Unavailable',
                        text: result.Message || 'Could not generate print link at this time.',
                        icon: 'warning',
                        confirmButtonColor: '#3b82f6'
                    });
                }
            } else {
                throw new Error("HTTP " + response.status);
            }
        } catch (error) {
            console.error('Error fetching quotation link for print:', error);
            Swal.fire({
                title: 'Error',
                text: 'Failed to fetch quotation link for printing.',
                icon: 'error',
                confirmButtonColor: '#ef4444'
            });
        }
    };

    const renderShowPanel = () => {
        if (!showView) return null;

        const inv = showView._quotation || {};
        const d = showView;

        const getInitials = (name) => {
            if (!name || name === '-' || name === 'NA' || name === 'N/A' || name === 'null') return '?';
            const trimmed = name.trim();

            // Handle phone numbers starting with + (e.g. +98451 → "98")
            if (trimmed.startsWith('+')) {
                return trimmed.substring(1).replace(/\D/g, '').substring(0, 2);
            }

            // Handle pure phone numbers (digits only, e.g. 9032378 → "90")
            const digitsOnly = trimmed.replace(/\D/g, '');
            if (digitsOnly.length >= 4 && /^\+?\d[\d\s\-()]+$/.test(trimmed)) {
                return digitsOnly.substring(0, 2);
            }

            const parts = trimmed.split(/\s+/);
            // Single word: only the first letter (e.g. "sandeep" → "S")
            if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
            // Multi-word: first letter of first + first letter of last word (e.g. "Shubham Mane" → "SM")
            return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
        };

        const leadDetail = d.leadDetail || {};
        const customerName = leadDetail.PersonName || d.ContactName || inv.CustomerName || inv.PersonName || '-';
        const customerPhone = leadDetail.MobileNo || d.ContactPhone || inv.MobileNo || '-';
        const customerEmail = leadDetail.EmailID || d.ContactEmail || '-';
        const leadNo = leadDetail.LeadNo || d.LeadId || inv.LeadId || '-';
        const profileImg = leadDetail.ProfileImgFileName || null;
        const initials = getInitials(customerName);

        const companyName = d.CompanyName || '-';
        const companyAddress = d.CompanyAddress || '-';
        const companyPhone = d.CompanyPhone || '-';
        const companyEmail = d.CompanyEmail || '-';
        const companyTax = d.CompanyTaxNumber || '-';
        const companyPan = d.CompanyPanNumber || '-';

        const invoiceNumber = d.QuoteNumber || d.InvoiceNumber || inv.InvoiceNumber || inv.Number || '-';
        const status = String(d.Status || inv.Status || 'Draft');
        const quotationDate = formatDate(d.QuotedAt || d.InvoicedAt || inv.InvoiceDate || '-', true);
        const validTill = formatDate(d.DueAt || d.ValidTill || inv.ExpiryDate || '-', true);
        const orderNo = d.OrderNumber || '-';
        const amount = d.Amount || inv.TotalAmount || inv.Amount || 0;
        let currencySymbol = d.CurrencySymbol || d._quotation?.CurrencySymbol || '$';
        if (currencySymbol === 'Rp') currencySymbol = '₹';

        const lineItems = d.quotationItems || [];
        const allTaxRows = [];
        let subTotal = 0;
        lineItems.forEach(item => {
            subTotal += parseFloat(item.Total || item.Price * item.Quantity || 0);
            (item.quotationItemTaxes || []).forEach(t => {
                allTaxRows.push({ name: t.Name, amount: t.Amount, rate: t.Rate });
            });
        });
        const grandTotal = parseFloat(amount) || subTotal + allTaxRows.reduce((s, t) => s + parseFloat(t.amount || 0), 0);

        const histories = d.quotationHistories || d.invoiceHistories || [];
        const termsHtml = d.CompanyTermCondition || d.TermsCondition || '';
        const notesHtml = d.QuoteNotes || d.Notes || d.InvoiceNotes || '';
        const footerHtml = d.QuoteFooter || d.Footer || d.InvoiceFooter || '';

        const billToName = d.BillToName || customerName;
        const billToTax = d.ContactTaxNumber || '';
        const billToPan = d.ContactPanNumber || '';
        const billToEmail = d.ContactEmail || customerEmail;
        const billToAddress = [d.BillToCity, d.BillToState, d.BillToCountry, d.BillToPincode]
            .filter(Boolean).join(', ') || d.ContactAddress || '';

        const shipToName = d.ShipToName || customerName;
        const shipToEmail = d.ShipToEmailId || '';
        const shipToAddress = [d.ShipToAddress, d.ShipToCity, d.ShipToState, d.ShipToCountry, d.ShipToPincode]
            .filter(Boolean).join(', ') || '';

        return (
            <div className="invoice-detail-overlay quotation-detail-overlay-layer" onClick={() => setShowView(null)}>
                <div className="invoice-detail-panel" onClick={(e) => e.stopPropagation()}>

                    <div className="detail-back-bar">
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10, cursor: 'pointer' }} onClick={() => setShowView(null)}>
                            <ArrowLeft size={18} />
                            <span style={{ fontSize: '18px', fontWeight: 700 }}>Back to Quotation</span>
                        </div>
                        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 12 }}>
                            <div style={{ color: '#64748b', cursor: 'pointer', position: 'relative' }} className="gear-icon-container">
                                <div onClick={() => setOperationsOpen(!operationsOpen)}>
                                    <Settings size={20} />
                                </div>
                                {operationsOpen && (
                                    <QuotationOperations
                                        showView={showView}
                                        setShowView={setShowView}
                                        onClose={() => setOperationsOpen(false)}
                                        getToken={getToken}
                                        fetchQuotations={fetchQuotations}
                                        handlePrint={handlePrint}
                                        handleMarkAsSent={handleMarkAsSent}
                                        setDownloadModalOpen={setDownloadModalOpen}
                                        setLeadAction={setLeadAction}
                                        crmOperationPerms={crmOperationPerms}
                                    />
                                )}
                            </div>
                        </div>
                    </div>

                    {detailLoading ? (
                        <div style={{ padding: '60px', display: 'flex', justifyContent: 'center' }}>
                            <Loader message="Fetching details..." />
                        </div>
                    ) : (
                        <div className="detail-content">

                            {/* Approval Header Panel */}
                            {getStandardStatus(status) === 'Sent For Approval' && Number(approversInfo?.Id || 0) > 0 && (
                                <div className="invoice-approval-header-panel">
                                    <div className="approval-panel-left">
                                        <div className="approval-status-icon-wrapper">
                                            <div className="approval-icon-bg">
                                                <img 
                                                    src="/waitingApproval.png" 
                                                    alt="approval" 
                                                    style={{ width: 48, height: 48 }}
                                                />
                                            </div>
                                        </div>
                                        <div className="approval-text-content">
                                            <h3 className="approval-title-modern">Approve the Quotation</h3>
                                            <p className="approval-subtitle-modern">
                                                This quotation has been submitted for approval. Verify and approve the quotation.
                                            </p>
                                        </div>
                                        <div className="approval-actions-modern">
                                            <button 
                                                className="btn-approve-modern"
                                                onClick={() => {
                                                    setApprovalState({ open: false, status: 'Approved', remarks: '', loading: false });
                                                    handleSaveApprovalByStatus('Approved');
                                                }}
                                            >
                                                Approve
                                            </button>
                                            <button 
                                                className="btn-reject-modern"
                                                onClick={() => {
                                                    setApprovalState({ open: false, status: 'Rejected', remarks: '', loading: false });
                                                    handleSaveApprovalByStatus('Rejected');
                                                }}
                                            >
                                                Reject
                                            </button>
                                        </div>
                                    </div>

                                    <div className="approval-panel-right">
                                        <div className="approvers-section-modern">
                                            <span className="approvers-label">APPROVERS</span>
                                            <div className="approver-info-card">
                                                <Avatar 
                                                    sx={{ 
                                                        width: 32, 
                                                        height: 32, 
                                                        fontSize: '13px',
                                                        bgcolor: '#f1f5f9',
                                                        color: '#64748b',
                                                        border: '1px solid #e2e8f0'
                                                    }}
                                                >
                                                    <User size={16} />
                                                </Avatar>
                                                <span className="approver-name">{approversInfo?.User || "Approver"}</span>
                                            </div>
                                        </div>
                                        <div className="approval-history-link-wrapper">
                                            <span className="approval-history-link-text">Approval History</span>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Customer Header - Modernized */}
                            <div className="detail-customer-header">
                                <div className="detail-customer-left">
                                    <div className="detail-avatar-container">
                                        <Avatar
                                            sx={{
                                                width: 56,
                                                height: 56,
                                                bgcolor: '#e0e7ff',
                                                color: '#4338ca',
                                                fontSize: '20px',
                                                fontWeight: 800,
                                                borderRadius: '50% !important',
                                                border: `2px solid #fff`,
                                                boxShadow: '0 4px 12px rgba(99, 102, 241, 0.15)'
                                            }}
                                        >
                                            {initials}
                                        </Avatar>
                                    </div>
                                    <div>
                                        <div className="detail-customer-name">{customerName}</div>
                                        <div className="detail-customer-meta">
                                            <span>{customerPhone}</span>
                                            {leadNo !== '-' && <span className="detail-invoice-ref" style={{ margin: 0, padding: '2px 8px', fontSize: '11px' }}>Lead No: {leadNo}</span>}
                                        </div>
                                    </div>
                                </div>
                                <div className="detail-invoice-ref">
                                    Quotation: {invoiceNumber}
                                </div>
                            </div>

                            {/* Status Info Bar - Modernized */}
                            <div className="detail-info-bar">
                                <div className="detail-info-col">
                                    <span className="detail-info-label">Current Status</span>
                                    <span className={`status-badge ${status.toLowerCase().replace(/\s+/g, '-')}`}>
                                        {status}
                                    </span>
                                </div>
                                <div className="detail-info-col">
                                    <span className="detail-info-label">Created Date</span>
                                    <span className="detail-info-value">{quotationDate}</span>
                                </div>
                                <div className="detail-info-col">
                                    <span className="detail-info-label">Valid Until</span>
                                    <span className="detail-info-value">{validTill}</span>
                                </div>
                                <div className="detail-info-col">
                                    <span className="detail-info-label">Total Amount</span>
                                    <span className="detail-info-value" style={{ color: '#0f172a', fontWeight: 800 }}>{currencySymbol} {parseFloat(amount || 0).toLocaleString()}</span>
                                </div>
                            </div>

                            {/* Company Details */}
                            <div className="detail-section">
                                <div className="detail-section-title" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <span>Quotation Summary</span>
                                    <span style={{ fontSize: '13px', color: '#64748b' }}>Date: {quotationDate}</span>
                                </div>
                                <div className="detail-grid-full">
                                    <div className="detail-field-row">
                                        <span className="field-label-fixed">Name:</span>
                                        <span className="field-value-rich">{companyName}</span>
                                    </div>
                                    <div className="detail-field-row">
                                        <span className="field-label-fixed">Address:</span>
                                        <span className="field-value-rich">{companyAddress}</span>
                                    </div>
                                    <div className="detail-field-row">
                                        <span className="field-label-fixed">Phone:</span>
                                        <span className="field-value-rich">{companyPhone}</span>
                                    </div>
                                    <div className="detail-field-row">
                                        <span className="field-label-fixed">Email:</span>
                                        <span className="field-value-rich">{companyEmail}</span>
                                    </div>
                                    <div className="detail-field-row">
                                        <span className="field-label-fixed">Tax:</span>
                                        <span className="field-value-rich">{companyTax}</span>
                                    </div>
                                    <div className="detail-field-row">
                                        <span className="field-label-fixed">Pan Number:</span>
                                        <span className="field-value-rich">{(companyPan && companyPan !== '-') ? companyPan : (companyTax && companyTax.length >= 12 ? companyTax.substring(2, 12) : '-')}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Bill To / Ship To */}
                            <div className="detail-section">
                                <div className="detail-grid-2">
                                    <div>
                                        <div className="detail-section-title">Bill To</div>
                                        <div className="detail-address-block">
                                            <div className="detail-addr-name">{billToName}</div>
                                            {billToTax && billToTax.trim() && <div className="detail-addr-line">Tax: {billToTax}</div>}
                                            {billToEmail && <div className="detail-addr-line">{billToEmail}</div>}
                                            {billToAddress && <div className="detail-addr-line">{billToAddress}</div>}
                                        </div>
                                    </div>
                                    <div>
                                        <div className="detail-section-title">Ship To</div>
                                        <div className="detail-address-block">
                                            <div className="detail-addr-name">{shipToName}</div>
                                            {shipToEmail && <div className="detail-addr-line">{shipToEmail}</div>}
                                            {shipToAddress && <div className="detail-addr-line">{shipToAddress}</div>}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Line Items Table */}
                            <div className="detail-section">
                                <div className="detail-section-title">Line Items</div>
                                <table className="detail-items-table">
                                    <thead>
                                        <tr>
                                            <th>PRODUCTS</th>
                                            <th>DESCRIPTION</th>
                                            <th style={{ textAlign: 'center' }}>VOLUME</th>
                                            <th style={{ textAlign: 'right' }}>PRICE</th>
                                            <th style={{ textAlign: 'right' }}>AMOUNT</th>
                                            <th style={{ textAlign: 'center' }}>HSN/SAC CODE</th>
                                            <th style={{ textAlign: 'center' }}>TAXES</th>
                                            <th style={{ textAlign: 'right' }}>TAXAMOUNT</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {lineItems.length > 0 ? lineItems.map((item, i) => {
                                            const itemTaxes = item.quotationItemTaxes || [];
                                            let hsnDisplayShow = '-';
                                            try {
                                                if (item.ProductJSON) {
                                                    const pData = JSON.parse(item.ProductJSON);
                                                    const code = pData.HSNCode || pData.SACCode;
                                                    if (code) hsnDisplayShow = `${pData.HSNCode ? 'HSN' : 'SAC'}: ${code}`;
                                                }
                                            } catch (e) {
                                                console.error("Error parsing ProductJSON", e);
                                            }

                                            return (
                                                <React.Fragment key={i}>
                                                    <tr>
                                                        <td style={{ fontWeight: 700, color: '#0f172a' }}>{item.Name || '-'}</td>
                                                        <td style={{ fontSize: '12px', maxWidth: '250px' }} className="detail-description-html" dangerouslySetInnerHTML={{ __html: item.Description || '' }}></td>
                                                        <td style={{ textAlign: 'center' }}>{item.Quantity || 1}</td>
                                                        <td style={{ textAlign: 'right' }}>{currencySymbol} {parseFloat(item.Price || 0).toLocaleString()}</td>
                                                        <td style={{ textAlign: 'right', fontWeight: 600 }}>{currencySymbol} {parseFloat(item.Total || 0).toLocaleString()}</td>
                                                        <td style={{ textAlign: 'center', color: '#64748b', fontSize: '12px' }}>{hsnDisplayShow}</td>
                                                        <td style={{ textAlign: 'center', color: '#94a3b8', fontSize: '11px' }}>NO DATA</td>
                                                        <td style={{ textAlign: 'right', color: '#94a3b8', fontSize: '11px' }}>NO DATA</td>
                                                    </tr>
                                                    {itemTaxes.map((t, ti) => (
                                                        <tr key={`tax-${i}-${ti}`} className="tax-subrow">
                                                            <td colSpan="4"></td>
                                                            <td style={{ textAlign: 'right', color: '#475569', fontWeight: 500 }}>{t.Name}</td>
                                                            <td colSpan="1"></td>
                                                            <td style={{ textAlign: 'center', color: '#475569' }}>{t.Rate && t.Rate !== 0 ? t.Rate : ''}</td>
                                                            <td style={{ textAlign: 'right', color: '#1e293b', fontWeight: 600 }}>{currencySymbol} {parseFloat(t.Amount || 0).toLocaleString()}</td>
                                                        </tr>
                                                    ))}
                                                </React.Fragment>
                                            );
                                        }) : (
                                            <tr>
                                                <td colSpan="8" style={{ textAlign: 'center', color: '#94a3b8', padding: '30px' }}>No items added</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* Totals Section */}
                                <div className="detail-totals">
                                    <div className="totals-row">
                                        <span>SUB TOTAL</span>
                                        <span>{currencySymbol} {subTotal.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
                                    </div>
                                    {allTaxRows.map((t, i) => (
                                        <div className="totals-row" key={i}>
                                            <span>{t.name.toUpperCase().replace(/_/g, ' ')}</span>
                                            <span>{currencySymbol} {parseFloat(t.amount || 0).toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
                                        </div>
                                    ))}
                                    <div className="totals-row grand-total-premium">
                                        <span>GRAND TOTAL</span>
                                        <span style={{ fontSize: '18px' }}>{currencySymbol} {grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2 })}</span>
                                    </div>
                                </div>
                            </div>

                            {/* Terms, Activity History */}
                            <div className="detail-section" style={{ border: 'none', background: 'transparent', boxShadow: 'none' }}>
                                {termsHtml && (
                                    <div style={{ marginBottom: '20px' }}>
                                        <div className="detail-collapsible-label" style={{ fontWeight: 700, color: '#0f172a' }}>Terms &amp; Conditions</div>
                                        <div className="detail-rich-text" dangerouslySetInnerHTML={{ __html: termsHtml }}></div>
                                    </div>
                                )}

                                {footerHtml && (
                                    <div style={{ marginBottom: '20px' }}>
                                        <button className="detail-collapsible-header" onClick={() => setShowFooter(!showFooter)}>
                                            <span>Footer</span>
                                            {showFooter ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                                        </button>
                                        {showFooter && (
                                            <div className="detail-collapsible-body">
                                                <div className="detail-collapsible-label" style={{ color: '#475569', marginBottom: 8 }}>Footer</div>
                                                <div className="detail-rich-text" style={{ border: '1px dashed #cbd5e1', padding: '16px', borderRadius: '4px', backgroundColor: '#fff', fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: footerHtml }}>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}

                                <button className="detail-collapsible-header" onClick={() => setShowHistory(!showHistory)}>
                                    <span>Activity History</span>
                                    {showHistory ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
                                </button>
                                {showHistory && (
                                    <div className="detail-collapsible-body">
                                        <table className="detail-history-table">
                                            <thead>
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Action</th>
                                                    <th>By</th>
                                                    <th>Remark</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {histories.length > 0 ? histories.map((h, i) => (
                                                    <tr key={i}>
                                                        <td><span style={{ fontWeight: 600 }}>{h.CreatedOn || '-'}</span></td>
                                                        <td>
                                                            <div className="action-badge-container">
                                                                <span className={`status-badge ${String(h.Status || '').toLowerCase().replace(/\s+/g, '-')}`}>
                                                                    {h.Status || '-'}
                                                                </span>
                                                            </div>
                                                        </td>
                                                        <td>{h.CreatedBy || '-'}</td>
                                                        <td dangerouslySetInnerHTML={{ __html: h.Discription || h.Description || '-' }}></td>
                                                    </tr>
                                                )) : (
                                                    <tr>
                                                        <td colSpan="4" style={{ textAlign: 'center', color: '#94a3b8', padding: '16px' }}>No activity logged</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>

                            {/* Footer Actions - Sticky */}
                            <div className="detail-sticky-footer">
                                <button className="btn-premium secondary" onClick={() => setShowView(null)}>
                                    Cancel
                                </button>
                                <button className="btn-premium primary" onClick={handleGenerateInvoice}>
                                    Generate Invoice
                                </button>
                            </div>

                        </div>
                    )}
                </div>
                {approvalState.open && renderApprovalModal()}
            </div>
        );
    };

    // ─── Main Render ──────────────────────────────────────────────────────────
    return (
        <>
            {/* Detail View Overlay */}
            {showView && renderShowPanel()}

            {/* Edit View Overlay */}
            {editView && renderEditPanel()}

            {/* Bill To Edit Modal */}
            {billToOpen && renderBillToModal()}

            {/* Ship To Edit Modal */}
            {shipToOpen && renderShipToModal()}

            {/* Item Edit Modals */}
            {renderItemEntityModal()}
            {renderItemDescriptionModal()}

            {/* Add Charges Modal */}
            {chargeModal.open && (
                <div className="billtto-modal-overlay" onClick={() => setChargeModal({ open: false, type: '', amount: '' })}>
                    <div className="billtto-modal charge-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="billtto-modal-header">
                            <span>Add Charges</span>
                            <button className="billtto-close-x" onClick={() => setChargeModal({ open: false, type: '', amount: '' })}>&times;</button>
                        </div>
                        <div className="billtto-modal-body" style={{ padding: '20px 24px' }}>
                            <label className="charge-label">Charge Type</label>
                            <select
                                className="charge-select"
                                value={chargeModal.type}
                                onChange={(e) => setChargeModal(prev => ({ ...prev, type: e.target.value, customName: '' }))}
                            >
                                <option value="">--Select Charge Type--</option>
                                <option value="Shipping Charge">Shipping Charge</option>
                                <option value="Adjustment">Adjustment</option>
                                <option value="Other">Other</option>
                            </select>
                            {chargeModal.type === 'Other' && (
                                <>
                                    <label className="charge-label" style={{ marginTop: 12 }}>Charge Name</label>
                                    <input
                                        type="text"
                                        className="charge-amount-input"
                                        placeholder="Enter Charge Name"
                                        value={chargeModal.customName || ''}
                                        onChange={(e) => setChargeModal(prev => ({ ...prev, customName: e.target.value }))}
                                    />
                                </>
                            )}
                            {chargeModal.type && (
                                <>
                                    <label className="charge-label" style={{ marginTop: 12 }}>Amount</label>
                                    <input
                                        type="number"
                                        className="charge-amount-input"
                                        placeholder="Enter Amount"
                                        value={chargeModal.amount}
                                        onChange={(e) => setChargeModal(prev => ({ ...prev, amount: e.target.value }))}
                                    />
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="charge-close-btn" onClick={() => setChargeModal({ open: false, type: '', amount: '' })}>close</button>
                            <button className="charge-apply-btn" onClick={() => {
                                if (!chargeModal.type || !chargeModal.amount) return;
                                const name = chargeModal.type === 'Other' ? (chargeModal.customName || 'Other') : chargeModal.type;
                                setAddedCharges(prev => [...prev, { type: name, amount: parseFloat(chargeModal.amount) || 0 }]);
                                setChargeModal({ open: false, type: '', amount: '' });
                            }}>Apply</button>
                        </div>
                    </div>
                </div>
            )}
            {/* Operations Modals */}
            {downloadModalOpen && <DownloadPdfModal showView={showView} onClose={() => setDownloadModalOpen(false)} getToken={getToken} DOWNLOAD_PDF={DOWNLOAD_PDF} />}

            {leadAction.open && (
                <div className="lead-action-modal-overlay" style={{
                    position: 'fixed', inset: 0, zIndex: 9999,
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    padding: '20px'
                }} onClick={() => setLeadAction({ ...leadAction, open: false })}>
                    <div className="lead-action-modal-content" style={{
                        backgroundColor: '#fff',
                        width: 'calc(100% - 40px)', maxWidth: '900px',
                        height: '85vh',
                        borderRadius: '12px',
                        display: 'flex', flexDirection: 'column',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
                        position: 'relative',
                        overflow: 'hidden'
                    }} onClick={e => e.stopPropagation()}>
                        <div style={{ flex: 1, overflowY: 'auto', position: 'relative' }}>
                            <LeadActionOperation
                                entity={{ leadId: leadAction.leadId }}
                                mode={leadAction.mode}
                                onBack={() => setLeadAction({ ...leadAction, open: false })}
                                onSuccess={() => {
                                    setLeadAction({ ...leadAction, open: false });
                                    if (fetchQuotations) fetchQuotations();
                                }}
                            />
                        </div>
                    </div>
                </div>
            )}
            {renderProductAddDrawer()}
        </>
    );
});

export default QuotationActionFilteration;

// ─── Sub-Component: Download PDF Modal Content ──────────────────────────────

const DownloadPdfModalContent = ({ showView, onClose, getToken, DOWNLOAD_PDF }) => {
    const [loading, setLoading] = useState(false);
    const defaultOption = { templateId: '0', templateName: 'System Default Template' };
    const [templates, setTemplates] = useState([defaultOption]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedTemplate, setSelectedTemplate] = useState(defaultOption);

    const GET_DOWNLOAD_TEMPLATE = `${NEW_BASE_URL_SERVICE}${API_ENDPOINTS.Quotation.GET_DOWNLOAD_TEMPLATE}`;

    const fetchTemplates = async () => {
        setLoading(true);
        try {
            const parentId = localStorage.getItem('ParentID') || '34594';
            const token = getToken() || "-2295521862261168";
            const payload = {
                Token: String(token),
                Details: {
                    operation: "GET",
                    templateId: null,
                    isActiveFilter: true,
                    parentId: String(parentId),
                    templateType: "quotation"
                }
            };
            const response = await fetch(GET_DOWNLOAD_TEMPLATE, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const data = await response.json();
                if (data?.Details && data.Details.length > 0) {
                    const jsonResult = data.Details[0].jsonResult;
                    const list = typeof jsonResult === 'string' ? JSON.parse(jsonResult) : jsonResult;
                    setTemplates([defaultOption, ...(Array.isArray(list) ? list : [])]);
                } else {
                    setTemplates([defaultOption]);
                }
            } else {
                setTemplates([defaultOption]);
            }
        } catch (error) {
            console.error('Error fetching download templates:', error);
            setTemplates([defaultOption]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTemplates();
    }, []);

    const handleDownload = async () => {
        if (!selectedTemplate) return;
        const isDefault = selectedTemplate.templateId === '0' || selectedTemplate.templateId === 0;
        const templateName = selectedTemplate.templateName || selectedTemplate.TemplateName;
        if (!isDefault && !templateName) return;

        setLoading(true);
        try {
            // Standardized ID extraction across the file
            const q = showView?._quotation || showView || {};
            const quotationId = q.QuoteId || q.QuotationId || q.ID || q.Id || showView?.id || showView?.Details?.QuotationId;

            if (!quotationId) throw new Error('Quotation ID not found');

            if (isDefault) {
                // Use the exact same form submission logic from the webforms project for the default template
                // The ASMX service and GeneratorOption.aspx are hosted on the main webforms domain, not the WCF API domain.
                const API_BASE = 'https://www.kit19.com'; 
                const form = document.createElement('form');
                form.method = 'POST';
                form.action = `${API_BASE}/UserCRMCampaign/Service/InvoiceService.asmx/DownloadQuotationHtmltoPdf`;

                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = 'QuotationId';
                input.value = quotationId;

                form.appendChild(input);
                document.body.appendChild(form);
                form.submit();
                document.body.removeChild(form);
                
                onClose();
                setLoading(false);
                return;
            }

            const templateUrl = `https://docs.kit19.com/kit19/DocumentTemplates/${templateName}.html`;

            const token = getToken() || "-2295521862261168";
            const payload = {
                Token: String(token),
                Details: {
                    QuotationId: parseInt(quotationId),
                    TemplateUrl: templateUrl,
                    IsPreview: false
                }
            };

            const response = await fetch(DOWNLOAD_PDF, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });

            if (!response.ok) throw new Error('Failed to generate PDF');

            const blob = await response.blob();
            const downloadUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = downloadUrl;
            link.download = `Quotation_${quotationId}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(downloadUrl);
            onClose();
        } catch (error) {
            console.error('Error downloading PDF:', error);
            Swal.fire({ title: 'Error', text: error.message || 'Failed to download PDF.', icon: 'error' });
        } finally {
            setLoading(false);
        }
    };

    const filteredTemplates = templates.filter(t =>
        (t.templateName || t.TemplateName || '').toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <div className="download-pdf-modal-root" onClick={onClose}>
            <div className="download-pdf-modal-container" onClick={e => e.stopPropagation()} style={{ height: '70vh' }}>
                <style>{`
                    .download-pdf-modal-root {
                        position: fixed; inset: 0; z-index: 9999999 !important;
                        display: flex; align-items: center; justify-content: center;
                        background: rgba(0, 0, 0, 0.7) !important;
                    }
                    .download-pdf-modal-container {
                        background-color: #ffffff !important; width: 500px; max-width: 95vw;
                        border-radius: 8px; box-shadow: 0 20px 60px rgba(0,0,0,0.3);
                        display: flex; flex-direction: column; overflow: hidden;
                        position: relative; z-index: 10000000 !important;
                    }
                    .download-pdf-modal-container * { opacity: 1 !important; color: inherit !important; }
                    .wa-template-item.selected { background-color: #f0f9ff; border-left: 4px solid #3b82f6; }
                `}</style>
                <div className="billtto-modal-header" style={{ borderBottom: '1px solid #eee' }}>
                    <span style={{ fontSize: '16px', fontWeight: 'bold', color: '#6b7280' }}>Download Quotation PDF</span>
                    <button className="billtto-close-x" onClick={onClose}>×</button>
                </div>
                <div className="wa-search-bar" style={{ padding: '12px 20px', borderBottom: '1px solid #e5e7eb' }}>
                    <div className="wa-search-input-wrapper" style={{ display: 'flex', alignItems: 'center', border: '1px solid #d1d5db', borderRadius: '4px', padding: '6px 12px', gap: '8px' }}>
                        <Search size={18} color="#9ca3af" />
                        <input
                            type="text" placeholder="Search Template" value={searchTerm}
                            onChange={e => setSearchTerm(e.target.value)}
                            style={{ border: 'none', outline: 'none', width: '100%', fontSize: '14px', color: '#374151' }}
                        />
                    </div>
                </div>
                <div className="wa-template-list" style={{ flex: 1, overflowY: 'auto' }}>
                    {loading && templates.length === 0 ? (
                        <div style={{ padding: '40px', textAlign: 'center' }}><Loader message="Loading templates..." /></div>
                    ) : filteredTemplates.length > 0 ? (
                        filteredTemplates.map((temp, i) => (
                            <div key={i} className={`wa-template-item ${selectedTemplate?.templateId === temp.templateId ? 'selected' : ''}`}
                                onClick={() => setSelectedTemplate(temp)}
                                style={{ padding: '12px 20px', display: 'flex', alignItems: 'center', gap: '15px', borderBottom: '1px solid #f3f4f6', cursor: 'pointer' }}>
                                <input type="radio" checked={selectedTemplate?.templateId === temp.templateId} onChange={() => setSelectedTemplate(temp)} />
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontWeight: '600', color: '#374151', fontSize: '14px' }}>{temp.templateName || temp.TemplateName}</div>
                                    {temp.isdefault && <span style={{ fontSize: '10px', backgroundColor: '#e0f2fe', color: '#0369a1', padding: '2px 6px', borderRadius: '10px' }}>Default</span>}
                                </div>
                            </div>
                        ))
                    ) : (
                        <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>
                            {loading ? 'Fetching templates...' : 'No templates found.'}
                        </div>
                    )}
                </div>

                <div className="billtto-modal-footer">
                    <button className="billtto-btn-close" onClick={onClose}>Cancel</button>
                    <button
                        className="billtto-btn-apply"
                        style={{ backgroundColor: '#00aeff', opacity: (!selectedTemplate || loading) ? 0.6 : 1 }}
                        onClick={handleDownload}
                        disabled={!selectedTemplate || loading}
                    >
                        {loading ? 'Processing...' : 'Download'}
                    </button>
                </div>
            </div>
        </div>
    );
};

const DownloadPdfModal = ({ showView, onClose, getToken, DOWNLOAD_PDF }) => {
    return (
        <DownloadPdfModalContent
            showView={showView}
            onClose={onClose}
            getToken={getToken}
            DOWNLOAD_PDF={DOWNLOAD_PDF}
        />
    );
};





const QuotationOperations = ({
    showView, editView, setShowView, onClose, getToken, fetchQuotations, handlePrint,
    handleMarkAsSent, setDownloadModalOpen, setLeadAction, crmOperationPerms
}) => {
    const activeView = showView || editView;
    const leadId = activeView?.LeadId || activeView?._quotation?.LeadId || activeView?.leadDetail?.LeadId || "";
    const status = String(activeView?.Status || activeView?.StatusName || activeView?._quotation?.Status || activeView?._quotation?.StatusName || '').toLowerCase();

    // Restricted statuses show only Approval History
    const isRestricted = status.includes('cancel') || status.includes('rej') || status.includes('sent for approval') || status.includes('sent-for-approval');

    const handleMarkAsSentInternal = async () => {
        await handleMarkAsSent(activeView);
        onClose();
    };

    const handleApprovalHistoryClick = () => {
        onClose();
        setTimeout(() => {
            const el = document.querySelector('.detail-history-table');
            if (el) el.scrollIntoView({ behavior: 'smooth' });
        }, 200);
    };

    return (
        <>
            <style>{`
                    .operations-dropdown {
                        position: absolute; right: 0; top: 100%; width: 220px;
                        background: #fff; border-radius: 8px; box-shadow: 0 10px 25px rgba(0,0,0,0.1);
                        z-index: 1000; padding: 8px 0; border: 1px solid #e5e7eb;
                    }
                    .dropdown-item {
                        display: flex; align-items: center; gap: 10px; padding: 10px 16px;
                        cursor: pointer; color: #374151; transition: all 0.2s; font-size: 14px;
                    }
                    .dropdown-item:hover { background-color: #f3f4f6; color: #111827; }
                    .dropdown-section { border-bottom: 1px solid #f3f4f6; margin-bottom: 4px; padding-bottom: 4px; }
                    .dropdown-sub-items { padding-left: 20px; display: flex; flex-direction: column; }
                    .dropdown-item.sub { padding: 6px 16px; font-size: 13px; color: #6b7280; }
                `}</style>
            <div className="operations-dropdown" onClick={e => e.stopPropagation()}>
                {!isRestricted && (
                    <>
                        <div className="dropdown-section">
                            <div className="dropdown-item parent"><Share2 size={16} /><span>Share Quotation</span></div>
                            <div className="dropdown-sub-items">
                                <div className="dropdown-item sub" onClick={() => { setLeadAction({ open: true, mode: 'mail', leadId }); onClose(); }}><Mail size={14} /><span>Email</span></div>
                                <div className="dropdown-item sub" onClick={() => { setLeadAction({ open: true, mode: 'sms', leadId }); onClose(); }}><MessageSquare size={14} /><span>SMS</span></div>
                                <div className="dropdown-item sub" onClick={() => { setLeadAction({ open: true, mode: 'whatsapp', leadId }); onClose(); }}><MessageCircle size={14} /><span>Whatsapp</span></div>
                            </div>
                        </div>
                        <div className="dropdown-item" onClick={handleMarkAsSentInternal}><Send size={16} /><span>Mark as Sent</span></div>
                        {crmOperationPerms?.Print !== false && (
                            <div className="dropdown-item" onClick={() => { handlePrint(); onClose(); }}><Printer size={16} /><span>Print</span></div>
                        )}
                        {crmOperationPerms?.Export !== false && (
                            <div className="dropdown-item" onClick={() => { setDownloadModalOpen(true); onClose(); }}><Download size={16} /><span>Download PDF</span></div>
                        )}
                    </>
                )}
                <div className="dropdown-item" onClick={handleApprovalHistoryClick}><History size={16} /><span>Approval History</span></div>
            </div>
        </>
    );
};




